/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: number; output: number; }
  Long: { input: number; output: number; }
  Void: { input: any; output: any; }
};

export type AccessConstraint = {
  partyRole?: InputMaybe<PartyRole>;
};

export type Address = {
  /** city is used for the city/town/village of the address */
  city?: Maybe<Scalars['String']['output']>;
  /** ISO country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Latitude */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  long?: Maybe<Scalars['Float']['output']>;
  /** postal identifier for the address */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** region is the state, region, or any other subdivision of the country */
  region?: Maybe<Scalars['String']['output']>;
  /** street contains the housing number and street name */
  street?: Maybe<Scalars['String']['output']>;
  /** street_additional is used for any other additional street identifying information */
  streetAdditional?: Maybe<Scalars['String']['output']>;
};

export type AddressFeatureValue = {
  addressValue: Address;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
};

export enum AffiliateType {
  Accounting = 'Accounting',
  Investment = 'Investment'
}

export type AppInstanceChallenge = {
  deviceId: Scalars['String']['input'];
  nonce: Scalars['Int']['input'];
  signature: Scalars['String']['input'];
  timestamp: Scalars['Long']['input'];
  userId: Scalars['String']['input'];
};

export type AppInstanceProfile = {
  appBundleId: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  appVersion: Scalars['String']['input'];
  deviceModel: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  deviceOs: Scalars['String']['input'];
  deviceOsVersion: Scalars['String']['input'];
};

export enum ArrivalContext {
  ClientPays = 'ClientPays',
  ClientPaysComposable = 'ClientPaysComposable',
  ReportsBuilder = 'ReportsBuilder',
  ResetClientPays = 'ResetClientPays'
}

export enum AsyncProcessingStatus {
  AsyncProcessingDone = 'AsyncProcessingDone',
  AsyncProcessingError = 'AsyncProcessingError',
  AsyncProcessingStarted = 'AsyncProcessingStarted',
  UnknownAsyncProcessingStatus = 'UnknownAsyncProcessingStatus'
}

export type BankAccount = {
  accountIdMask: Scalars['String']['output'];
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  isAutoPayout: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
};

export type BeginLogin = {
  requiresSSO: Scalars['Boolean']['output'];
  ssoIdentityProviderId?: Maybe<Scalars['String']['output']>;
  ssoIssuerURL?: Maybe<Scalars['String']['output']>;
  ssoOrganizationId?: Maybe<Scalars['String']['output']>;
};

export type BillPaymentPreview = {
  amount: MonetaryValue;
  billId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image: BillPaymentPreviewSegment;
  payerCompanyName: Scalars['String']['output'];
  payerEmailAddress: Scalars['String']['output'];
  vendor: PartyPreview;
};

export type BillPaymentPreviewSegment = {
  collectionId: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type CardBillingAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
};

export enum CardPaymentResultStatus {
  /** Payment was successful */
  Authorised = 'Authorised',
  /** An error occurred */
  Error = 'Error',
  /** Additional action required (e.g., 3DS) */
  Pending = 'Pending',
  /** Payment is being processed */
  Received = 'Received',
  /** Payment was refused */
  Refused = 'Refused',
  Unknown = 'Unknown'
}

export type CategoryPreview = {
  displayKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: CategoryType;
};

export enum CategoryType {
  Assets = 'Assets',
  CostOfGoodsSold = 'CostOfGoodsSold',
  Equity = 'Equity',
  Expenses = 'Expenses',
  Income = 'Income',
  Liabilities = 'Liabilities',
  OtherExpenses = 'OtherExpenses',
  OtherIncome = 'OtherIncome',
  UnknownType = 'UnknownType'
}

export type ConfirmationToken = {
  token: Scalars['String']['output'];
};

export type Contact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  emailAddress: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCard = {
  /** Card brand (e.g., visa, mastercard, amex) */
  cardBrand?: Maybe<Scalars['String']['output']>;
  /** Expiration month (1-12) */
  cardExpiryMonth?: Maybe<Scalars['Long']['output']>;
  /** Expiration year (e.g., 2025) */
  cardExpiryYear?: Maybe<Scalars['Long']['output']>;
  /** Last 4 digits of the card number */
  cardLastFour?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  nickname: Scalars['String']['output'];
};

export type Customer = {
  address?: Maybe<CustomerAddress>;
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerType: ProviderType;
};

export type CustomerAddress = {
  address?: Maybe<Address>;
  id: Scalars['String']['output'];
};

export type CustomerSummary = {
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Date = {
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DateFeatureValue = {
  dateValue: Date;
};

export type DateInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Discount = {
  categoryId?: Maybe<Scalars['String']['output']>;
  dataSourceId?: Maybe<Scalars['String']['output']>;
  discountId: Scalars['String']['output'];
  fixedDiscountAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  providerType: ProviderType;
  variablePercentage?: Maybe<Scalars['Float']['output']>;
};

export enum DisplayEntry {
  Credit = 'Credit',
  Debit = 'Debit',
  TransferCredit = 'TransferCredit',
  TransferDebit = 'TransferDebit',
  Unknown = 'Unknown'
}

export type DocumentDownload = {
  url: Scalars['String']['output'];
};

export type DocumentLineItem = {
  amount: MonetaryValue;
  categoryId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  quantity: Scalars['Long']['output'];
  quantityMultiplier?: Maybe<Scalars['Long']['output']>;
  rate: MonetaryValue;
};

export enum DocumentStatus {
  Done = 'Done',
  New = 'New',
  Processing = 'Processing',
  UnknownStatus = 'UnknownStatus'
}

export type EmployeeLegalEntityRole = {
  legalEntityId: Scalars['String']['output'];
  role?: Maybe<Role>;
};

export type EntityLegalEntity = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type EntityOrganization = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type EntityUser = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type Feature = {
  featurePage: Scalars['Long']['output'];
  /**
   * Restored after #3327 removed it: stale iOS and web clients still in
   * the wild select this field. Server populates it from `groups`,
   * picking the LineItem-kind group for line-item features and the first
   * group otherwise. New code should use `groups` and filter by kind;
   * this field will be removed again once the long-tail clients migrate.
   * @deprecated Use `groups` and filter by kind.
   */
  group?: Maybe<FeatureGroup>;
  /**
   * A feature may be a member of more than one group (e.g. LineItem +
   * AccountGroup on multi-account bank statements). Readers iterate
   * `groups` and filter by kind.
   */
  groups?: Maybe<Array<FeatureGroup>>;
  height: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  invalid: Scalars['Boolean']['output'];
  kind: FeatureKind;
  originX: Scalars['Float']['output'];
  originY: Scalars['Float']['output'];
  value: FeatureValue;
  width: Scalars['Float']['output'];
};

export type FeatureGroup = {
  featureGroupId: Scalars['String']['output'];
  kind: FeatureKind;
  position: Scalars['Long']['output'];
};

export enum FeatureKind {
  AccountExternalId = 'AccountExternalId',
  /**
   * feature-group kinds used when a feature is a member of a grouping
   * (e.g. per-account groups on multi-account bank statements)
   */
  AccountGroup = 'AccountGroup',
  AccountName = 'AccountName',
  AccountNumber = 'AccountNumber',
  AccountType = 'AccountType',
  AmountDue = 'AmountDue',
  BankAddress = 'BankAddress',
  BankCategory = 'BankCategory',
  BankStatementLineItem = 'BankStatementLineItem',
  BillCategory = 'BillCategory',
  /** budget feature kinds */
  Budget = 'Budget',
  BudgetAccountGroupName = 'BudgetAccountGroupName',
  BudgetAccountGroupNumber = 'BudgetAccountGroupNumber',
  BudgetArchetype = 'BudgetArchetype',
  BudgetCategoryHint = 'BudgetCategoryHint',
  BudgetCheckResult = 'BudgetCheckResult',
  BudgetConfidenceBasisPoints = 'BudgetConfidenceBasisPoints',
  BudgetDepartmentName = 'BudgetDepartmentName',
  BudgetEndDate = 'BudgetEndDate',
  BudgetExtractorId = 'BudgetExtractorId',
  BudgetExtractorVersion = 'BudgetExtractorVersion',
  BudgetImportTargetBudgetId = 'BudgetImportTargetBudgetId',
  BudgetIntervalName = 'BudgetIntervalName',
  BudgetLine = 'BudgetLine',
  BudgetLineAmount = 'BudgetLineAmount',
  BudgetLocationName = 'BudgetLocationName',
  BudgetMappingSource = 'BudgetMappingSource',
  BudgetName = 'BudgetName',
  BudgetPartyName = 'BudgetPartyName',
  BudgetPeriod = 'BudgetPeriod',
  BudgetPeriodAmount = 'BudgetPeriodAmount',
  BudgetPeriodIndex = 'BudgetPeriodIndex',
  BudgetPeriodMonth = 'BudgetPeriodMonth',
  BudgetPeriodSourceCell = 'BudgetPeriodSourceCell',
  BudgetPeriodStartDate = 'BudgetPeriodStartDate',
  BudgetSourceFile = 'BudgetSourceFile',
  BudgetSourceRow = 'BudgetSourceRow',
  BudgetSourceTab = 'BudgetSourceTab',
  BudgetStartDate = 'BudgetStartDate',
  BudgetTargetCategory = 'BudgetTargetCategory',
  BudgetTargetCategoryName = 'BudgetTargetCategoryName',
  BudgetTruncated = 'BudgetTruncated',
  BudgetValidationNote = 'BudgetValidationNote',
  BudgetVerificationGreen = 'BudgetVerificationGreen',
  BusinessAddress = 'BusinessAddress',
  /** W9 feature kinds */
  BusinessName = 'BusinessName',
  CertificationSigned = 'CertificationSigned',
  ChartOfAccounts = 'ChartOfAccounts',
  ChartOfAccountsAccount = 'ChartOfAccountsAccount',
  ChartOfAccountsAccountingBasis = 'ChartOfAccountsAccountingBasis',
  ChartOfAccountsActive = 'ChartOfAccountsActive',
  ChartOfAccountsCategorySubtype = 'ChartOfAccountsCategorySubtype',
  ChartOfAccountsCategoryType = 'ChartOfAccountsCategoryType',
  ChartOfAccountsConfidenceBasisPoints = 'ChartOfAccountsConfidenceBasisPoints',
  ChartOfAccountsDescription = 'ChartOfAccountsDescription',
  ChartOfAccountsEffectiveDate = 'ChartOfAccountsEffectiveDate',
  ChartOfAccountsExtractorVersion = 'ChartOfAccountsExtractorVersion',
  ChartOfAccountsName = 'ChartOfAccountsName',
  ChartOfAccountsNumber = 'ChartOfAccountsNumber',
  ChartOfAccountsNumberingScheme = 'ChartOfAccountsNumberingScheme',
  ChartOfAccountsParentName = 'ChartOfAccountsParentName',
  ChartOfAccountsParentNumber = 'ChartOfAccountsParentNumber',
  ChartOfAccountsRecordIndex = 'ChartOfAccountsRecordIndex',
  ChartOfAccountsSection = 'ChartOfAccountsSection',
  ChartOfAccountsSectionName = 'ChartOfAccountsSectionName',
  ChartOfAccountsSourceAccountType = 'ChartOfAccountsSourceAccountType',
  ChartOfAccountsSourceFile = 'ChartOfAccountsSourceFile',
  CheckInfo = 'CheckInfo',
  /** check feature kinds */
  CheckNumber = 'CheckNumber',
  CheckPayee = 'CheckPayee',
  DocumentCustomer = 'DocumentCustomer',
  DocumentDate = 'DocumentDate',
  DocumentKeyword = 'DocumentKeyword',
  DocumentParty = 'DocumentParty',
  /** generic document feature kinds */
  DocumentRawText = 'DocumentRawText',
  DocumentReference = 'DocumentReference',
  DocumentSummary = 'DocumentSummary',
  DocumentType = 'DocumentType',
  DocumentTypeReasoning = 'DocumentTypeReasoning',
  DocumentVendor = 'DocumentVendor',
  DueDate = 'DueDate',
  EndingBalance = 'EndingBalance',
  EndingDate = 'EndingDate',
  ExemptPayeeCode = 'ExemptPayeeCode',
  FatcaExemptionCode = 'FatcaExemptionCode',
  FormRevision = 'FormRevision',
  Iban = 'Iban',
  InstitutionAccountNumber = 'InstitutionAccountNumber',
  /** bank statement feature kinds */
  InstitutionName = 'InstitutionName',
  InvoiceDate = 'InvoiceDate',
  InvoiceId = 'InvoiceId',
  LLCTaxClassification = 'LLCTaxClassification',
  LineItem = 'LineItem',
  LineItemAmount = 'LineItemAmount',
  LineItemDate = 'LineItemDate',
  LineItemDescription = 'LineItemDescription',
  Memo = 'Memo',
  Other = 'Other',
  OtherPaymentInfo = 'OtherPaymentInfo',
  OtherTaxClassification = 'OtherTaxClassification',
  PayerAddress = 'PayerAddress',
  PayerCompanyName = 'PayerCompanyName',
  PayerEmail = 'PayerEmail',
  PayerName = 'PayerName',
  PayerPhoneNumber = 'PayerPhoneNumber',
  PaymentInstructions = 'PaymentInstructions',
  PreviousBalance = 'PreviousBalance',
  ReceiptNumber = 'ReceiptNumber',
  /** receipt feature kinds */
  ReceiptPaymentProcessor = 'ReceiptPaymentProcessor',
  RemittanceAddress = 'RemittanceAddress',
  /** binds a remittance item's anchor feature to its SwiftCode/Iban/BankAddress */
  RemittanceGroup = 'RemittanceGroup',
  RemittanceInformation = 'RemittanceInformation',
  /** contract and schedule extraction feature kinds */
  Schedule = 'Schedule',
  ScheduleAccountGroupName = 'ScheduleAccountGroupName',
  ScheduleAccountGroupNumber = 'ScheduleAccountGroupNumber',
  ScheduleAccrualFormulaText = 'ScheduleAccrualFormulaText',
  ScheduleAccumulatedToDateAmount = 'ScheduleAccumulatedToDateAmount',
  ScheduleAmount = 'ScheduleAmount',
  ScheduleArchetype = 'ScheduleArchetype',
  ScheduleAsOfDate = 'ScheduleAsOfDate',
  ScheduleCategoryHint = 'ScheduleCategoryHint',
  ScheduleCheckResult = 'ScheduleCheckResult',
  ScheduleConfidenceBasisPoints = 'ScheduleConfidenceBasisPoints',
  ScheduleEndDate = 'ScheduleEndDate',
  ScheduleExtractorId = 'ScheduleExtractorId',
  ScheduleExtractorVersion = 'ScheduleExtractorVersion',
  ScheduleFormulaDisplay = 'ScheduleFormulaDisplay',
  ScheduleFormulaId = 'ScheduleFormulaId',
  ScheduleImportCutoverDate = 'ScheduleImportCutoverDate',
  ScheduleInterval = 'ScheduleInterval',
  ScheduleItem = 'ScheduleItem',
  ScheduleMappingSource = 'ScheduleMappingSource',
  ScheduleName = 'ScheduleName',
  ScheduleNotYetCreatable = 'ScheduleNotYetCreatable',
  SchedulePaidDate = 'SchedulePaidDate',
  SchedulePartyName = 'SchedulePartyName',
  SchedulePeriod = 'SchedulePeriod',
  SchedulePeriodAmount = 'SchedulePeriodAmount',
  SchedulePeriodIndex = 'SchedulePeriodIndex',
  SchedulePeriodMonth = 'SchedulePeriodMonth',
  ScheduleSalvageValueAmount = 'ScheduleSalvageValueAmount',
  ScheduleSourceAccount = 'ScheduleSourceAccount',
  ScheduleSourceFile = 'ScheduleSourceFile',
  ScheduleSourceRow = 'ScheduleSourceRow',
  ScheduleSourceTab = 'ScheduleSourceTab',
  ScheduleSpecialization = 'ScheduleSpecialization',
  ScheduleStartDate = 'ScheduleStartDate',
  ScheduleTargetCategory = 'ScheduleTargetCategory',
  ScheduleTargetCategoryName = 'ScheduleTargetCategoryName',
  ScheduleTermIntervals = 'ScheduleTermIntervals',
  ScheduleType = 'ScheduleType',
  ScheduleValidationNote = 'ScheduleValidationNote',
  ScheduleVerificationGreen = 'ScheduleVerificationGreen',
  StartingBalance = 'StartingBalance',
  StartingDate = 'StartingDate',
  /**
   * wire-remittance attributes stored as their own string features and
   * reassembled onto RemittanceItem via a RemittanceGroup
   */
  SwiftCode = 'SwiftCode',
  TaxClassification = 'TaxClassification',
  TaxNumber = 'TaxNumber',
  TaxNumberApplied = 'TaxNumberApplied',
  TaxNumberEncrypted = 'TaxNumberEncrypted',
  TaxNumberLastFour = 'TaxNumberLastFour',
  TaxNumberType = 'TaxNumberType',
  TaxpayerName = 'TaxpayerName',
  Terms = 'Terms',
  Title = 'Title',
  TotalAmount = 'TotalAmount',
  TotalCashback = 'TotalCashback',
  TotalCredits = 'TotalCredits',
  TotalDebits = 'TotalDebits',
  TotalDeposits = 'TotalDeposits',
  TotalDividends = 'TotalDividends',
  TotalFees = 'TotalFees',
  TotalInterestCharged = 'TotalInterestCharged',
  TotalInterestEarned = 'TotalInterestEarned',
  TotalWithdrawals = 'TotalWithdrawals',
  TrialBalance = 'TrialBalance',
  TrialBalanceAccountName = 'TrialBalanceAccountName',
  TrialBalanceAccountNumber = 'TrialBalanceAccountNumber',
  TrialBalanceCategorySubtype = 'TrialBalanceCategorySubtype',
  TrialBalanceCategoryType = 'TrialBalanceCategoryType',
  TrialBalanceCompleteAndBalanced = 'TrialBalanceCompleteAndBalanced',
  TrialBalanceCreditAmount = 'TrialBalanceCreditAmount',
  TrialBalanceDebitAmount = 'TrialBalanceDebitAmount',
  TrialBalanceExtractorVersion = 'TrialBalanceExtractorVersion',
  TrialBalanceFlippedAmount = 'TrialBalanceFlippedAmount',
  TrialBalanceReportedTotalCredits = 'TrialBalanceReportedTotalCredits',
  TrialBalanceReportedTotalDebits = 'TrialBalanceReportedTotalDebits',
  TrialBalanceRow = 'TrialBalanceRow',
  TrialBalanceSectionName = 'TrialBalanceSectionName',
  TrialBalanceTruncated = 'TrialBalanceTruncated',
  TrialBalanceValidationNote = 'TrialBalanceValidationNote',
  UnknownKind = 'UnknownKind',
  VendorAddress = 'VendorAddress',
  VendorEmail = 'VendorEmail',
  VendorName = 'VendorName',
  VendorPhoneNumber = 'VendorPhoneNumber',
  VendorWebsite = 'VendorWebsite',
  WireInfo = 'WireInfo'
}

export type FeatureValue = AddressFeatureValue | DateFeatureValue | LineItemFeatureValue | MonetaryFeatureValue | NumericFeatureValue | RemittanceFeatureValue | TextFeatureValue;

export enum Flow {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  UnknownFlow = 'UnknownFlow'
}

export type Identity = {
  domain?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  provider: OAuthService;
};

export type InputMonetaryValue = {
  amount: Scalars['Long']['input'];
  currencyMultiplier: Scalars['Long']['input'];
  iso4217CurrencyCode: Scalars['String']['input'];
};

/**
 * ObjectIdentifier is a generic identifier with an enumerated kind.
 * It can be used to identify different Digits' core objects.
 */
export type InputObjectIdentifier = {
  id: Scalars['String']['input'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};

export type InputQuantityValue = {
  quantity: Scalars['Long']['input'];
  quantityMultiplier: Scalars['Long']['input'];
};

export enum Interval {
  Biweek = 'Biweek',
  Day = 'Day',
  Hour = 'Hour',
  IntervalNone = 'IntervalNone',
  Minute = 'Minute',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export type Invitation = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  invitationType: InvitationType;
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  recipient: Contact;
  role?: Maybe<Role>;
  sender?: Maybe<Contact>;
  service?: Maybe<OAuthService>;
  signupId?: Maybe<Scalars['String']['output']>;
  status: InvitationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvitationProposal = {
  createdAt: Scalars['DateTime']['output'];
  invitationId: Scalars['String']['output'];
  legalEntity?: Maybe<EntityLegalEntity>;
  organization?: Maybe<EntityOrganization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  proposalId: Scalars['String']['output'];
  proposalType: ProposalType;
  recipient?: Maybe<Contact>;
  sender?: Maybe<EntityUser>;
  status: InvitationProposalStatus;
};

export enum InvitationProposalStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Rejected = 'Rejected',
  Sent = 'Sent',
  Unknown = 'Unknown'
}

export enum InvitationStatus {
  Accepted = 'Accepted',
  Active = 'Active',
  Cancelled = 'Cancelled',
  Unknown = 'Unknown'
}

export type InvitationToken = {
  token: Scalars['String']['output'];
};

export enum InvitationType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  Passwordless = 'Passwordless',
  UnknownType = 'UnknownType'
}

export type Invoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  status: InvoiceStatus;
  statusSummary?: Maybe<InvoiceStatusSummary>;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type InvoiceBranding = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  coverURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** Result of a card payment submission */
export type InvoiceCardPaymentResult = {
  /** Action data for additional authentication (3DS) - pass to handleAction */
  actionData?: Maybe<Scalars['String']['output']>;
  /** Card brand (e.g. "visa", "mc") */
  cardBrand?: Maybe<Scalars['String']['output']>;
  /** Last four digits of the card */
  cardLastFour?: Maybe<Scalars['String']['output']>;
  /** Error message if payment failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Payment confirmation ID (if successful) */
  paymentConfirmationId?: Maybe<Scalars['String']['output']>;
  /** Adyen PSP reference */
  pspReference?: Maybe<Scalars['String']['output']>;
  /** Refusal reason code from Adyen (if refused) */
  refusalReasonCode?: Maybe<Scalars['String']['output']>;
  /** Result status of the payment attempt */
  result: CardPaymentResultStatus;
};

export type InvoiceDiscount = {
  amount: MonetaryValue;
  discount: Discount;
  discountAmount?: Maybe<MonetaryValue>;
  invoiceDiscountId: Scalars['String']['output'];
};

export type InvoiceFile = {
  documentId: Scalars['String']['output'];
  fileType?: Maybe<InvoiceFileType>;
};

export enum InvoiceFileType {
  InvoicePDF = 'InvoicePDF',
  Unknown = 'Unknown'
}

export type InvoiceLineItem = {
  amount: MonetaryValue;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  quantityValue?: Maybe<QuantityValue>;
  sku?: Maybe<Scalars['String']['output']>;
  taxable: Scalars['Boolean']['output'];
  unitPrice: MonetaryValue;
};

export type InvoiceNumber = {
  invoiceNumber: Scalars['String']['output'];
};

export type InvoicePaymentDetails = {
  paymentAmount: MonetaryValue;
  paymentConfirmationId: Scalars['String']['output'];
  paymentDate: Scalars['DateTime']['output'];
  paymentInstrument: PaymentInstrument;
};

/**
 * Card Payment Types
 * Adyen payment methods for card payments
 */
export type InvoicePaymentMethods = {
  /** Client key for initializing Adyen on the frontend */
  clientKey: Scalars['String']['output'];
  /** Environment (test or live) */
  environment: Scalars['String']['output'];
  /** Available payment methods as JSON string */
  paymentMethodsResponse?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceStatus {
  Cancelled = 'Cancelled',
  Created = 'Created',
  /** adding this temporarily to fix an ops issue */
  Draft = 'Draft',
  Failed = 'Failed',
  ManuallySent = 'ManuallySent',
  MarkedAsPaid = 'MarkedAsPaid',
  OnHold = 'OnHold',
  Paid = 'Paid',
  PaymentCanceled = 'PaymentCanceled',
  PaymentProcessing = 'PaymentProcessing',
  PaymentRejected = 'PaymentRejected',
  PaymentRequiresAttention = 'PaymentRequiresAttention',
  PaymentReturned = 'PaymentReturned',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Sent = 'Sent',
  Settled = 'Settled',
  Submitted = 'Submitted',
  Unknown = 'Unknown',
  UnspecifiedBillStatus = 'UnspecifiedBillStatus',
  Voided = 'Voided'
}

export type InvoiceStatusSummary = {
  internalNoteForStatus?: Maybe<Scalars['String']['output']>;
  invoiceSentDate: Scalars['DateTime']['output'];
  status: InvoiceStatus;
  statusAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoicingAddress = {
  address: Address;
  id: Scalars['String']['output'];
};

export type InvoicingProfile = {
  companyAddress: InvoicingAddress;
  companyEmail: Scalars['String']['output'];
  companyIcon?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  invoiceNumberFormat?: Maybe<Scalars['String']['output']>;
  invoiceNumberFormatDefault: Scalars['String']['output'];
  payoutInstrumentID: Scalars['String']['output'];
};

export type LedgerBillPreview = {
  amount: MonetaryValue;
  billId: Scalars['String']['output'];
  dueDate?: Maybe<Date>;
  externalId: Scalars['String']['output'];
  image?: Maybe<BillPaymentPreviewSegment>;
  invoiceDate?: Maybe<Date>;
  payerCompanyName: Scalars['String']['output'];
  payerEmailAddress: Scalars['String']['output'];
  vendor: LedgerBillPreviewVendor;
};

export type LedgerBillPreviewVendor = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LegalEntityNumberFormat = {
  inheritedFormat: NegativeNumberFormat;
  legalEntityId: Scalars['String']['output'];
  negativeNumberFormat: NegativeNumberFormat;
  override: NegativeNumberFormat;
};

export type LegalEntityRoleOptions = {
  legalEntityId: Scalars['String']['output'];
  legalEntityRoles: Array<Role>;
  organizationRoles: Array<Role>;
};

export enum LegalEntityStatus {
  Active = 'Active',
  Approved = 'Approved',
  New = 'New',
  Pending = 'Pending',
  PendingHold = 'PendingHold',
  Removed = 'Removed',
  Unknown = 'Unknown'
}

export type LineItemFeatureValue = {
  lineItemValue: DocumentLineItem;
};

export enum MagicLinkRequestScheme {
  Digits = 'Digits',
  Https = 'Https'
}

export enum MetricType {
  COGS = 'COGS',
  Expenses = 'Expenses',
  GrossProfit = 'GrossProfit',
  Income = 'Income',
  NetIncome = 'NetIncome',
  NetOperatingIncome = 'NetOperatingIncome',
  ProfitPercentage = 'ProfitPercentage'
}

export enum MfaMethod {
  RecoveryCode = 'RecoveryCode',
  TOTP = 'TOTP',
  UnknownMfaMethod = 'UnknownMfaMethod'
}

export type MonetaryFeatureValue = {
  monetaryValue: MonetaryValue;
};

/** MonetaryValue */
export type MonetaryValue = {
  amount: Scalars['Long']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  iso4217CurrencyCode: Scalars['String']['output'];
};

export type MoneyFlow = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['output'];
  value: MonetaryValue;
};

export type MoneyFlowInput = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['input'];
  value: InputMonetaryValue;
};

export type Mutation = {
  addSignup: PublicSignup;
  beginLogin: BeginLogin;
  /**
   * Completes a pending MFA challenge issued by a login RPC. The challengeToken
   * is the opaque value surfaced in error.extensions.error.mfa_challenge_token
   * on a FailedPrecondition response from logInEmail.
   */
  completeMfaChallenge: Session;
  createPasswordReset?: Maybe<Scalars['Void']['output']>;
  createPaymentPlaidLinkToken: PlaidLinkToken;
  createPlaidGuestBankAccountInstrument: PaymentInstrument;
  /** Handles additional actions required by Adyen (e.g., 3DS authentication) */
  handleInvoiceCardPaymentAction: InvoiceCardPaymentResult;
  /** Handles additional Adyen actions for a ledger invoice (e.g., 3DS authentication) */
  ledgerHandleInvoiceCardPaymentAction: InvoiceCardPaymentResult;
  ledgerPayInvoice: PayInvoiceSummary;
  /** Submits a card payment for a ledger invoice using encrypted card data from Adyen */
  ledgerSubmitInvoiceCardPayment: InvoiceCardPaymentResult;
  logInAppInstance: Session;
  logInEmail: Session;
  logInEmailWithAttest: Session;
  logInMagicLink: Session;
  logInOAuth: Session;
  logInSSOHandoff: Session;
  /** Support */
  logInSupport: Session;
  logOut?: Maybe<Scalars['Void']['output']>;
  logOutSupport: Session;
  payInvoice: PayInvoiceSummary;
  provisionVerificationToken: ConfirmationToken;
  registerInviteOAuth: Session;
  registerInvitePasswordless: Session;
  registerUserEmail: Session;
  registerUserEmailToken: RegistrationStatus;
  registerUserOAuth: Session;
  resetPassword: Session;
  /** Saves the complete reviewed form; accounting validates and completes the collection request. */
  saveW9Form?: Maybe<Scalars['Void']['output']>;
  sendAcceptedInvitationMagicLink?: Maybe<Scalars['Void']['output']>;
  sendEmailVerification?: Maybe<Scalars['Void']['output']>;
  sendMagicLinkEmail?: Maybe<Scalars['Void']['output']>;
  /** Submits a card payment for an invoice using encrypted card data from Adyen */
  submitInvoiceCardPayment: InvoiceCardPaymentResult;
  tokenRefresh: Session;
  unsubscribe?: Maybe<Scalars['Void']['output']>;
  updateSignup: PublicSignup;
  updateSignupFromOAuth: PublicSignup;
};


export type MutationAddSignupArgs = {
  attribution?: InputMaybe<SignupAttribution>;
  email: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<Persona>;
  planIntent?: InputMaybe<PlanIntent>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBeginLoginArgs = {
  emailAddress: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompleteMfaChallengeArgs = {
  challengeToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
  method: MfaMethod;
};


export type MutationCreatePasswordResetArgs = {
  billId?: InputMaybe<Scalars['String']['input']>;
  contactToken?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  intentId?: InputMaybe<Scalars['String']['input']>;
  ledgerBillId?: InputMaybe<Scalars['String']['input']>;
  object?: InputMaybe<InputObjectIdentifier>;
};


export type MutationCreatePaymentPlaidLinkTokenArgs = {
  plaidClientUserId: Scalars['String']['input'];
};


export type MutationCreatePlaidGuestBankAccountInstrumentArgs = {
  accountId: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  useNewPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationHandleInvoiceCardPaymentActionArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  invoiceId: Scalars['String']['input'];
  paymentDetails: Scalars['String']['input'];
};


export type MutationLedgerHandleInvoiceCardPaymentActionArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  expectedAmount: InputMonetaryValue;
  invoiceId: Scalars['String']['input'];
  paymentDetails: Scalars['String']['input'];
};


export type MutationLedgerPayInvoiceArgs = {
  expectedAmount: InputMonetaryValue;
  invoiceId: Scalars['String']['input'];
  paymentInstrumentId: Scalars['String']['input'];
};


export type MutationLedgerSubmitInvoiceCardPaymentArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  expectedAmount: InputMonetaryValue;
  holderName?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  paymentMethodData: Scalars['String']['input'];
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
  riskData?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLogInAppInstanceArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  challenge: AppInstanceChallenge;
  id: Scalars['String']['input'];
  profile: AppInstanceProfile;
};


export type MutationLogInEmailArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLogInEmailWithAttestArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  attestation: Scalars['String']['input'];
  challenge: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  keyId: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLogInMagicLinkArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationLogInOAuthArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationLogInSsoHandoffArgs = {
  clientId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  codeVerifier: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};


export type MutationLogInSupportArgs = {
  id: Scalars['String']['input'];
};


export type MutationLogOutSupportArgs = {
  id: Scalars['String']['input'];
};


export type MutationPayInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  paymentInstrumentId: Scalars['String']['input'];
  receivableInvoiceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProvisionVerificationTokenArgs = {
  emailAddress: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  intentId: Scalars['String']['input'];
  object: InputObjectIdentifier;
};


export type MutationRegisterInviteOAuthArgs = {
  code: Scalars['String']['input'];
  invitationToken: Scalars['String']['input'];
  service: OAuthService;
  timezone: Scalars['String']['input'];
};


export type MutationRegisterInvitePasswordlessArgs = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  invitationToken: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterUserEmailArgs = {
  confirmToken: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterUserEmailTokenArgs = {
  confirmToken: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterUserOAuthArgs = {
  code: Scalars['String']['input'];
  service: OAuthService;
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};


export type MutationSaveW9FormArgs = {
  form: W9FormInput;
  viewPartyId: Scalars['String']['input'];
};


export type MutationSendAcceptedInvitationMagicLinkArgs = {
  invitationToken: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendEmailVerificationArgs = {
  billId?: InputMaybe<Scalars['String']['input']>;
  constraint?: InputMaybe<AccessConstraint>;
  contactToken?: InputMaybe<Scalars['String']['input']>;
  destination: VerificationRequestDestination;
  emailAddress: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  intentId?: InputMaybe<Scalars['String']['input']>;
  object?: InputMaybe<InputObjectIdentifier>;
  requestParameters?: InputMaybe<Array<RequestParameter>>;
};


export type MutationSendMagicLinkEmailArgs = {
  emailAddress: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubmitInvoiceCardPaymentArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  paymentMethodData: Scalars['String']['input'];
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
  riskData?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTokenRefreshArgs = {
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnsubscribeArgs = {
  emailAddress: Scalars['String']['input'];
  notificationToken: Scalars['String']['input'];
};


export type MutationUpdateSignupArgs = {
  companyCurrency?: InputMaybe<Scalars['String']['input']>;
  companyLedger?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyURL?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  positionTitle?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSignupFromOAuthArgs = {
  code: Scalars['String']['input'];
  id: Scalars['String']['input'];
  service: OAuthService;
};

export enum NegativeNumberFormat {
  MinusSign = 'MinusSign',
  Parentheses = 'Parentheses',
  UnsetNegativeNumberFormat = 'UnsetNegativeNumberFormat'
}

export type NumericFeatureValue = {
  numericValue: Scalars['Long']['output'];
};

export enum OAuthService {
  Google = 'Google',
  LinkedIn = 'LinkedIn',
  QuickBooks = 'QuickBooks',
  Unknown = 'Unknown'
}

export enum ObjectKind {
  Bill = 'Bill',
  Budget = 'Budget',
  Category = 'Category',
  Comment = 'Comment',
  Connection = 'Connection',
  DataSource = 'DataSource',
  Department = 'Department',
  Discount = 'Discount',
  Institution = 'Institution',
  Invoice = 'Invoice',
  LedgerTransaction = 'LedgerTransaction',
  LegalEntity = 'LegalEntity',
  Location = 'Location',
  Party = 'Party',
  Portal = 'Portal',
  Product = 'Product',
  Reconciliation = 'Reconciliation',
  Report = 'Report',
  ReportPackage = 'ReportPackage',
  Schedule = 'Schedule',
  Thread = 'Thread',
  Transaction = 'Transaction',
  User = 'User',
  WorkItem = 'WorkItem'
}

export type Organization = {
  branding?: Maybe<OrganizationBranding>;
  displayId?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<OrganizationKind>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationBranding = {
  headerColor: Scalars['String']['output'];
  headerTextColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type OrganizationEmployment = {
  employeeId: Scalars['String']['output'];
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  organization: Organization;
  role: Role;
};

export enum OrganizationKind {
  AccountingFirm = 'AccountingFirm',
  Developer = 'Developer',
  Operator = 'Operator',
  SandboxAccountingFirm = 'SandboxAccountingFirm',
  SandboxOperator = 'SandboxOperator',
  UnknownKind = 'UnknownKind'
}

export type OrganizationPreferences = {
  anonymizeEmployees: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  negativeNumberFormat?: Maybe<NegativeNumberFormat>;
};

export type OrganizationTemplate = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PartyPreview = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum PartyRole {
  EntityAssetRole = 'EntityAssetRole',
  EntityAssetSupplierRole = 'EntityAssetSupplierRole',
  EntityAssetVendorRole = 'EntityAssetVendorRole',
  EntityBanksRole = 'EntityBanksRole',
  EntityCreditCardsRole = 'EntityCreditCardsRole',
  EntityCustomerRole = 'EntityCustomerRole',
  EntityDebtorRole = 'EntityDebtorRole',
  EntityInvesteeRole = 'EntityInvesteeRole',
  EntityLenderRole = 'EntityLenderRole',
  EntityLiabilitiesRole = 'EntityLiabilitiesRole',
  EntityOtherExpensesRole = 'EntityOtherExpensesRole',
  EntityOtherIncomeRole = 'EntityOtherIncomeRole',
  EntityOtherLiabilitiesRole = 'EntityOtherLiabilitiesRole',
  EntityOwedVendorRole = 'EntityOwedVendorRole',
  EntityPrepaidVendorRole = 'EntityPrepaidVendorRole',
  EntityProcessorRole = 'EntityProcessorRole',
  EntityRevenuePartnerRole = 'EntityRevenuePartnerRole',
  EntityShareholderRole = 'EntityShareholderRole',
  EntitySupplierRole = 'EntitySupplierRole',
  EntityUnpaidCustomerRole = 'EntityUnpaidCustomerRole',
  EntityUnspecifiedRole = 'EntityUnspecifiedRole',
  EntityVendorRole = 'EntityVendorRole',
  FacilitatorRole = 'FacilitatorRole',
  InstitutionCreditRole = 'InstitutionCreditRole',
  InstitutionDebitRole = 'InstitutionDebitRole',
  OwnerRole = 'OwnerRole',
  PaymentProcessorRole = 'PaymentProcessorRole',
  UnknownRole = 'UnknownRole'
}

export type PasswordReset = {
  contact: Contact;
  isValid: Scalars['Boolean']['output'];
};

export type PayInvoiceSummary = {
  invoicePaymentDetails: InvoicePaymentDetails;
  status: InvoiceStatus;
};

export type PaymentInstrument = BankAccount | CreditCard;

export enum PaymentStatus {
  Blocked = 'Blocked',
  Canceled = 'Canceled',
  Created = 'Created',
  Deposited = 'Deposited',
  Held = 'Held',
  Mailed = 'Mailed',
  OnHold = 'OnHold',
  Paid = 'Paid',
  Pending = 'Pending',
  PendingApproval = 'PendingApproval',
  PendingIncreaseReview = 'PendingIncreaseReview',
  PendingMailing = 'PendingMailing',
  PendingSubmission = 'PendingSubmission',
  ProcessingReturn = 'ProcessingReturn',
  ProcessingSettlement = 'ProcessingSettlement',
  Refunded = 'Refunded',
  Rejected = 'Rejected',
  RequiresAttention = 'RequiresAttention',
  Returned = 'Returned',
  Settled = 'Settled',
  Stopped = 'Stopped',
  Submitted = 'Submitted',
  Unknown = 'Unknown'
}

export type Period = {
  endedAt: Scalars['DateTime']['output'];
  interval: Interval;
  name: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type PeriodInput = {
  endedAt: Scalars['DateTime']['input'];
  interval: Interval;
  name: Scalars['String']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export enum Persona {
  AccountingLarge = 'AccountingLarge',
  AccountingMedium = 'AccountingMedium',
  AccountingSmall = 'AccountingSmall',
  Business = 'Business',
  BusinessAndSubsidiaries = 'BusinessAndSubsidiaries',
  InvestmentMedium = 'InvestmentMedium',
  InvestmentSmall = 'InvestmentSmall',
  MailingList = 'MailingList',
  UnknownPersona = 'UnknownPersona'
}

export type PlaidLinkToken = {
  token: Scalars['String']['output'];
};

export enum PlanIntent {
  AIAccountingPlan = 'AIAccountingPlan',
  AffiliatedAIAccountingPlan = 'AffiliatedAIAccountingPlan',
  AffiliatedFirmBooksPlan = 'AffiliatedFirmBooksPlan',
  AffiliatedLedgerOnlyPlan = 'AffiliatedLedgerOnlyPlan',
  AffiliatedLowVolumePlan = 'AffiliatedLowVolumePlan',
  AffiliatedReportsOnlyPlan = 'AffiliatedReportsOnlyPlan',
  DeveloperPlan = 'DeveloperPlan',
  FreePlan = 'FreePlan',
  GrowthPlan = 'GrowthPlan',
  PremiumPlan = 'PremiumPlan',
  ProspectFirmPlan = 'ProspectFirmPlan',
  UnknownPlan = 'UnknownPlan'
}

export enum ProposalType {
  AffiliateInviteManagedOperator = 'AffiliateInviteManagedOperator',
  AffiliationAssistClient = 'AffiliationAssistClient',
  AffiliationCreateClient = 'AffiliationCreateClient',
  AffiliationJoinClient = 'AffiliationJoinClient',
  CreateOrganization = 'CreateOrganization',
  EmploymentAssistOperator = 'EmploymentAssistOperator',
  EmploymentJoinOrg = 'EmploymentJoinOrg',
  EnterprisePackageInvite = 'EnterprisePackageInvite',
  OperatorAssistAffiliate = 'OperatorAssistAffiliate',
  UnknownProposalType = 'UnknownProposalType'
}

export enum ProviderType {
  CSVImport = 'CSVImport',
  Connect = 'Connect',
  Derived = 'Derived',
  Digits = 'Digits',
  DigitsInvoicing = 'DigitsInvoicing',
  DigitsLedgerInvoicing = 'DigitsLedgerInvoicing',
  DigitsLedgerPay = 'DigitsLedgerPay',
  DigitsPay = 'DigitsPay',
  DigitsPaymentsLedger = 'DigitsPaymentsLedger',
  DigitsSchedule = 'DigitsSchedule',
  Manual = 'Manual',
  ObjectIdentifier = 'ObjectIdentifier',
  Plaid = 'Plaid',
  QuickBooks = 'QuickBooks',
  UnknownProvider = 'UnknownProvider',
  VendorW9 = 'VendorW9',
  Xero = 'Xero'
}

export type PublicInvoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type PublicSignup = {
  companyCurrency?: Maybe<Scalars['String']['output']>;
  companyLedger?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyURL?: Maybe<Scalars['String']['output']>;
  contact: Contact;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  persona: Persona;
  planIntent: PlanIntent;
  positionTitle?: Maybe<Scalars['String']['output']>;
  status: SignupStatus;
  verificationMethod: VerificationMethod;
};

export type QuantityValue = {
  quantity: Scalars['Long']['output'];
  quantityMultiplier: Scalars['Long']['output'];
};

export type Query = {
  /** Retrieves Adyen payment methods for paying an invoice with a card */
  getInvoicePaymentMethods: InvoicePaymentMethods;
  /**
   * Pay-based Bills aren't object-identifiable right now.
   * this is bill payment
   * @deprecated Use previewLedgerBill instead.
   */
  previewBillPayment: BillPaymentPreview;
  previewLedgerBill: LedgerBillPreview;
  previewShare: SharePreview;
  publicDocumentDownloadUrl: DocumentDownload;
  readInvitation: Invitation;
  readInvitationRecipient: UserContact;
  readPasswordReset: PasswordReset;
  readSSORequirement: SsoRequirement;
  readSignup: PublicSignup;
  readW9CollectionDocument: W9CollectionDocument;
  /**
   * Returns decrypted features from an ingested W-9 document to prefill the collection form.
   * Access requires the document registered to the active W-9 request.
   */
  readW9CollectionFeatures: W9CollectionFeatures;
  /** Business branding is available without a W-9 request; completed is false without a resolved request. */
  readW9Requester: W9Requester;
  viewInvoice: ViewInvoiceSummary;
  viewInvoiceFiles: Array<InvoiceFile>;
};


export type QueryGetInvoicePaymentMethodsArgs = {
  amount: InputMonetaryValue;
  invoiceId: Scalars['String']['input'];
  invoiceLegalEntityId: Scalars['String']['input'];
  payerLegalEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewBillPaymentArgs = {
  contactToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryPreviewLedgerBillArgs = {
  contactToken: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryPreviewShareArgs = {
  id: Scalars['String']['input'];
  intentId?: InputMaybe<Scalars['String']['input']>;
  kind: ObjectKind;
};


export type QueryPublicDocumentDownloadUrlArgs = {
  documentId: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
};


export type QueryReadInvitationArgs = {
  token: Scalars['String']['input'];
};


export type QueryReadInvitationRecipientArgs = {
  token: Scalars['String']['input'];
};


export type QueryReadPasswordResetArgs = {
  resetToken: Scalars['String']['input'];
};


export type QueryReadSsoRequirementArgs = {
  emailAddress: Scalars['String']['input'];
};


export type QueryReadSignupArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadW9CollectionDocumentArgs = {
  documentId: Scalars['String']['input'];
  viewPartyId: Scalars['String']['input'];
};


export type QueryReadW9CollectionFeaturesArgs = {
  documentId: Scalars['String']['input'];
  viewPartyId: Scalars['String']['input'];
};


export type QueryReadW9RequesterArgs = {
  viewPartyId: Scalars['String']['input'];
};


export type QueryViewInvoiceArgs = {
  id: Scalars['String']['input'];
};


export type QueryViewInvoiceFilesArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type RegistrationStatus = {
  alreadyRegistered?: Maybe<Scalars['Boolean']['output']>;
  session?: Maybe<Session>;
};

export type RemittanceFeatureValue = {
  remittanceValue: RemittanceItem;
};

export type RemittanceItem = {
  BankAccountName?: Maybe<Scalars['String']['output']>;
  BankAccountNumber: Scalars['String']['output'];
  BankName: Scalars['String']['output'];
  BankRoutingNumber: Scalars['String']['output'];
  RemittanceType: RemittanceType;
};

export enum RemittanceType {
  ACH = 'ACH',
  Unknown = 'Unknown',
  Wire = 'Wire'
}

export enum ReportKind {
  APAging = 'APAging',
  ARAging = 'ARAging',
  BalanceSheet = 'BalanceSheet',
  Budget = 'Budget',
  CashFlow = 'CashFlow',
  ExpenseSummary = 'ExpenseSummary',
  ProfitAndLoss = 'ProfitAndLoss',
  Unknown = 'Unknown'
}

export type ReportPackagePreview = {
  author: EntityUser;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  interval: Interval;
  periodEndedAt: Scalars['DateTime']['output'];
  periodStartedAt: Scalars['DateTime']['output'];
  preparedBy?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type RequestParameter = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Role = {
  id: Scalars['String']['output'];
};

export type RoleIdentifier = {
  id: Scalars['String']['input'];
};

export type SsoRequirement = {
  requiresSSO: Scalars['Boolean']['output'];
  ssoIdentityProviderId?: Maybe<Scalars['String']['output']>;
  ssoIssuerURL?: Maybe<Scalars['String']['output']>;
  ssoOrganizationId?: Maybe<Scalars['String']['output']>;
};

export enum SandboxIndustry {
  Retail = 'Retail',
  Technology = 'Technology',
  UnknownIndustry = 'UnknownIndustry'
}

export enum SandboxType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  UnknownSandboxType = 'UnknownSandboxType'
}

export type SentInvoiceUsers = {
  invoice: Invoice;
  users?: Maybe<Array<User>>;
};

export type Session = {
  bearer: Scalars['String']['output'];
  employments?: Maybe<Array<SessionEmployment>>;
};

export type SessionAffiliation = {
  id: Scalars['String']['output'];
  kind?: Maybe<AffiliateType>;
  organization: SessionOrganization;
};

export enum SessionBillingMode {
  Billed = 'Billed',
  Included = 'Included',
  UnknownMode = 'UnknownMode'
}

export type SessionBillingPayer = {
  kind: SessionPayerKind;
  stripeSubscription: SessionSubscriptionStatus;
};

export type SessionEmployment = {
  affiliations: Array<SessionAffiliation>;
  id: Scalars['String']['output'];
  organization: SessionOrganization;
};

export type SessionLegalEntity = {
  affiliatedOrganizationIds: Array<Scalars['String']['output']>;
  aspects: Array<Scalars['String']['output']>;
  billing?: Maybe<SessionLegalEntityBilling>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: LegalEntityStatus;
  viewKeys: Array<SessionViewKey>;
};

export type SessionLegalEntityBilling = {
  payer: SessionBillingPayer;
  productCoverage?: Maybe<SessionProductCoverage>;
};

export type SessionOrganization = {
  aspects?: Maybe<Array<Scalars['String']['output']>>;
  /** Set only on the employing organization, not on affiliation organizations. */
  billing?: Maybe<SessionOrganizationBilling>;
  branding?: Maybe<SessionOrganizationBranding>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<OrganizationKind>;
  legalEntities: Array<SessionLegalEntity>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type SessionOrganizationBilling = {
  /**
   * True when the billing database has a Stripe subscription ID recorded for the
   * organization, live or not (Canceled and Incomplete keep their IDs). Not an
   * attach gate by itself: an Incomplete subscription has an ID but rejects
   * attachments, so combine this bit with stripeSubscription.
   */
  hasStripeSubscription: Scalars['Boolean']['output'];
  /**
   * Observed status. UnknownStatus with hasStripeSubscription true means the state
   * is not observed yet.
   */
  stripeSubscription: SessionSubscriptionStatus;
};

export type SessionOrganizationBranding = {
  headerColor: Scalars['String']['output'];
  headerTextColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum SessionPayerKind {
  AffiliatePaid = 'AffiliatePaid',
  SelfPaid = 'SelfPaid',
  UnknownKind = 'UnknownKind'
}

export type SessionProductCoverage = {
  legacy: Scalars['Boolean']['output'];
  mode: SessionBillingMode;
};

export enum SessionSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  PastDue = 'PastDue',
  Trialing = 'Trialing',
  UnknownStatus = 'UnknownStatus',
  Unpaid = 'Unpaid'
}

export type SessionViewKey = {
  legalEntityId: Scalars['String']['output'];
  mutationVersion?: Maybe<Scalars['String']['output']>;
  viewType?: Maybe<ViewType>;
  viewVersion?: Maybe<Scalars['String']['output']>;
};

export type ShareObject = CategoryPreview | PartyPreview | ReportPackagePreview | TransactionPreview;

export type SharePreview = {
  legalEntity: EntityLegalEntity;
  object: ShareObject;
  /** Invited user email. */
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type SignupAttribution = {
  fromCommunity?: InputMaybe<Scalars['Boolean']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmId?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum SignupStatus {
  Applied = 'Applied',
  Approved = 'Approved',
  Ignored = 'Ignored',
  InviteAccepted = 'InviteAccepted',
  Invited = 'Invited',
  PrimerSent = 'PrimerSent',
  Qualified = 'Qualified',
  Unknown = 'Unknown',
  Unqualified = 'Unqualified',
  Waitlisted = 'Waitlisted'
}

export enum TaxStatus {
  NonTaxable = 'NonTaxable',
  Taxable = 'Taxable',
  Undetermined = 'Undetermined',
  UnspecifiedTaxStatus = 'UnspecifiedTaxStatus'
}

export type TextFeatureValue = {
  textValue: Scalars['String']['output'];
};

export type TransactionPreview = {
  creditCategory?: Maybe<CategoryPreview>;
  debitCategory?: Maybe<CategoryPreview>;
  description?: Maybe<Scalars['String']['output']>;
  displayEntry: DisplayEntry;
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<PartyPreview>;
  timestamp: Scalars['DateTime']['output'];
};

export type User = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employments?: Maybe<Array<OrganizationEmployment>>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identities?: Maybe<Array<Identity>>;
  lastActivityAt: Scalars['DateTime']['output'];
  /** Timestamp when the user activated an MFA factor (e.g. TOTP). Null when no factor is enrolled. */
  mfaEnforcedAt?: Maybe<Scalars['DateTime']['output']>;
  passwordSet: Scalars['Boolean']['output'];
  primaryEmailAddress: Scalars['String']['output'];
};

export type UserContact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum VerificationMethod {
  AlreadyVerified = 'AlreadyVerified',
  Email = 'Email',
  Google = 'Google',
  UnknownVerificationMethod = 'UnknownVerificationMethod'
}

export enum VerificationRequestDestination {
  AIAccounting = 'AIAccounting',
  Bill = 'Bill',
  Developer = 'Developer',
  LedgerBill = 'LedgerBill',
  ProspectFirm = 'ProspectFirm',
  Share = 'Share',
  StartBusiness = 'StartBusiness',
  StartDeveloper = 'StartDeveloper',
  StartFirm = 'StartFirm',
  StartUnknown = 'StartUnknown',
  Unspecified = 'Unspecified'
}

export type ViewInvoiceSummary = {
  creditCardsEnabled: Scalars['Boolean']['output'];
  invoice: PublicInvoice;
  invoicePaymentDetails?: Maybe<InvoicePaymentDetails>;
  isPayable: Scalars['Boolean']['output'];
  useNewPaymentProvider: Scalars['Boolean']['output'];
};

export type ViewKey = {
  legalEntityId: Scalars['String']['input'];
  mutationVersion?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewType>;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};

export enum ViewType {
  AIBookkeeper = 'AIBookkeeper',
  Ledger = 'Ledger',
  Unknown = 'Unknown'
}

export type W9CollectionDocument = {
  asyncProcessingStatus: AsyncProcessingStatus;
  status: DocumentStatus;
};

export type W9CollectionFeatures = {
  /**
   * Poll readDocument until asyncProcessingStatus is AsyncProcessingDone before reading extracted fields.
   * TaxNumber can contain a decrypted SSN/EIN. Never log it.
   */
  features: Array<Feature>;
};

/** Complete reviewed values, not a patch. Omitted optional values clear old values. */
export type W9FormInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address: AddressInput;
  businessName?: InputMaybe<Scalars['String']['input']>;
  certificationSigned: Scalars['Boolean']['input'];
  /** Both document identifiers must be supplied together, or both omitted. */
  documentCollectionId?: InputMaybe<Scalars['String']['input']>;
  documentDate: Scalars['DateTime']['input'];
  documentId?: InputMaybe<Scalars['String']['input']>;
  exemptPayeeCode?: InputMaybe<Scalars['String']['input']>;
  fatcaExemptionCode?: InputMaybe<Scalars['String']['input']>;
  formRevision?: InputMaybe<Scalars['String']['input']>;
  llcTaxClassification?: InputMaybe<W9LlcTaxClassification>;
  otherTaxClassification?: InputMaybe<Scalars['String']['input']>;
  taxClassification: W9TaxClassification;
  /** Full plaintext SSN/EIN. Never log the form or attach it to traces/errors. */
  taxNumber: Scalars['String']['input'];
  taxNumberType: W9TaxNumberType;
  taxpayerName: Scalars['String']['input'];
};

export enum W9LlcTaxClassification {
  C = 'C',
  P = 'P',
  S = 'S'
}

export type W9Requester = {
  completed: Scalars['Boolean']['output'];
  iconUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum W9TaxClassification {
  CCorporation = 'CCorporation',
  Individual = 'Individual',
  LLC = 'LLC',
  Other = 'Other',
  Partnership = 'Partnership',
  SCorporation = 'SCorporation',
  TrustEstate = 'TrustEstate'
}

export enum W9TaxNumberType {
  EIN = 'EIN',
  SSN = 'SSN'
}

export type CategoryPreviewFieldsFragment = Pick<CategoryPreview, 'name' | 'displayKey' | 'type'>;

export type InvoiceAddressFieldsFragment = (
  Pick<InvoicingAddress, 'id'>
  & { address: PublicAddressFieldsFragment }
);

export type InvoiceFieldsFragment = (
  Pick<
    PublicInvoice,
    | 'id'
    | 'receivableInvoiceId'
    | 'legalEntityId'
    | 'status'
    | 'invoiceNumber'
    | 'invoiceDate'
    | 'dueDate'
    | 'taxPercent'
    | 'memo'
    | 'referenceNumber'
  >
  & {
    invoicingProfile?: Maybe<InvoiceProfileFieldsFragment>,
    customer?: Maybe<PublicCustomerFieldsFragment>,
    branding: PublicInvoiceBrandingFieldsFragment,
    lineItems: Array<PublicInvoiceLineItemFieldsFragment>,
    totalTax?: Maybe<PublicMonetaryValueFieldsFragment>,
    subtotal?: Maybe<PublicMonetaryValueFieldsFragment>,
    totalAmount?: Maybe<PublicMonetaryValueFieldsFragment>,
    discounts?: Maybe<Array<PublicInvoiceDiscountFieldsFragment>>,
    files?: Maybe<Array<PublicInvoiceFileFieldsFragment>>,
  }
);

export type InvoiceProfileFieldsFragment = (
  Pick<
    InvoicingProfile,
    | 'id'
    | 'companyEmail'
    | 'companyName'
    | 'companyIcon'
    | 'payoutInstrumentID'
    | 'invoiceNumberFormatDefault'
    | 'invoiceNumberFormat'
  >
  & { companyAddress: InvoiceAddressFieldsFragment }
);

export type PartyPreviewFieldsFragment = Pick<PartyPreview, 'id' | 'name' | 'iconUrl'>;

export type PublicAddressFieldsFragment = Pick<
    Address,
    | 'street'
    | 'streetAdditional'
    | 'city'
    | 'region'
    | 'postalCode'
    | 'countryCode'
    | 'lat'
    | 'long'
  >;

export type PublicBankAccountFieldsFragment = (
  { __typename: 'BankAccount' }
  & Pick<
    BankAccount,
    | 'id'
    | 'institutionName'
    | 'name'
    | 'accountIdMask'
    | 'isDefault'
    | 'nickname'
    | 'isAutoPayout'
    | 'iconObjectName'
  >
);

export type PublicCreditCardFieldsFragment = (
  { __typename: 'CreditCard' }
  & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
);

export type PublicCustomerAddressFieldsFragment = (
  Pick<CustomerAddress, 'id'>
  & { address?: Maybe<PublicAddressFieldsFragment> }
);

export type PublicCustomerFieldsFragment = (
  Pick<
    Customer,
    | 'id'
    | 'name'
    | 'email'
    | 'icon'
    | 'providerType'
  >
  & { address?: Maybe<PublicCustomerAddressFieldsFragment> }
);

export type PublicDiscountFieldsFragment = (
  Pick<
    Discount,
    | 'discountId'
    | 'name'
    | 'variablePercentage'
    | 'providerType'
  >
  & { fixedDiscountAmount?: Maybe<PublicMonetaryValueFieldsFragment> }
);

export type PublicEntityUserFieldsFragment = Pick<
    EntityUser,
    | 'id'
    | 'givenName'
    | 'familyName'
    | 'emailAddress'
    | 'avatarUrl'
  >;

export type PublicInvoiceBrandingFieldsFragment = Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'>;

export type PublicInvoiceDiscountFieldsFragment = (
  Pick<InvoiceDiscount, 'invoiceDiscountId'>
  & {
    discount: PublicDiscountFieldsFragment,
    amount: PublicMonetaryValueFieldsFragment,
    discountAmount?: Maybe<PublicMonetaryValueFieldsFragment>,
  }
);

export type PublicInvoiceFileFieldsFragment = Pick<InvoiceFile, 'documentId' | 'fileType'>;

export type PublicInvoiceLineItemFieldsFragment = (
  Pick<
    InvoiceLineItem,
    | 'description'
    | 'id'
    | 'name'
    | 'taxable'
    | 'productId'
    | 'sku'
    | 'imageUrl'
    | 'position'
  >
  & {
    amount: PublicMonetaryValueFieldsFragment,
    unitPrice: PublicMonetaryValueFieldsFragment,
    discounts?: Maybe<Array<PublicInvoiceDiscountFieldsFragment>>,
    quantityValue?: Maybe<Pick<QuantityValue, 'quantity' | 'quantityMultiplier'>>,
  }
);

export type PublicInvoicePaymentDetailsFieldsFragment = (
  Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
  & {
    paymentAmount: PublicMonetaryValueFieldsFragment,
    paymentInstrument:
      | PublicBankAccountFieldsFragment
      | PublicCreditCardFieldsFragment
    ,
  }
);

export type PublicLedgerBillPreviewFieldsFragment = (
  Pick<
    LedgerBillPreview,
    | 'billId'
    | 'externalId'
    | 'payerCompanyName'
    | 'payerEmailAddress'
  >
  & {
    amount: PublicMonetaryValueFieldsFragment,
    vendor: Pick<LedgerBillPreviewVendor, 'name' | 'email'>,
    invoiceDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    image?: Maybe<Pick<BillPaymentPreviewSegment, 'collectionId' | 'fileId' | 'token'>>,
  }
);

export type PublicMonetaryValueFieldsFragment = Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>;

export type PublicPayInvoiceSummaryFieldsFragment = (
  Pick<PayInvoiceSummary, 'status'>
  & { invoicePaymentDetails: PublicInvoicePaymentDetailsFieldsFragment }
);

export type PublicSignupFieldsFragment = (
  Pick<
    PublicSignup,
    | 'id'
    | 'positionTitle'
    | 'companyName'
    | 'companyURL'
    | 'companyLedger'
    | 'companyCurrency'
    | 'industry'
    | 'status'
    | 'persona'
    | 'verificationMethod'
    | 'planIntent'
  >
  & { contact: Pick<
      Contact,
      | 'avatarUrl'
      | 'familyName'
      | 'givenName'
      | 'emailAddress'
    > }
);

export type SessionFieldsFragment = (
  Pick<Session, 'bearer'>
  & { employments?: Maybe<Array<EmploymentFieldsFragment>> }
);

export type EmploymentFieldsFragment = (
  Pick<SessionEmployment, 'id'>
  & {
    organization: SessionOrganizationFieldsFragment,
    affiliations: Array<SessionAffiliationFieldsFragment>,
  }
);

export type SessionOrganizationFieldsFragment = (
  Pick<
    SessionOrganization,
    | 'id'
    | 'name'
    | 'kind'
    | 'slug'
    | 'iconUrl'
    | 'websiteUrl'
    | 'aspects'
  >
  & {
    branding?: Maybe<SessionOrganizationBrandingFieldsFragment>,
    billing?: Maybe<Pick<SessionOrganizationBilling, 'stripeSubscription' | 'hasStripeSubscription'>>,
    legalEntities: Array<SessionLegalEntityFieldsFragment>,
  }
);

export type SessionLegalEntityFieldsFragment = (
  Pick<
    SessionLegalEntity,
    | 'id'
    | 'name'
    | 'slug'
    | 'iconUrl'
    | 'status'
    | 'aspects'
    | 'affiliatedOrganizationIds'
  >
  & {
    viewKeys: Array<SessionViewKeyFieldsFragment>,
    billing?: Maybe<SessionLegalEntityBillingFieldsFragment>,
  }
);

export type SessionLegalEntityBillingFieldsFragment = {
    payer: Pick<SessionBillingPayer, 'kind' | 'stripeSubscription'>,
    productCoverage?: Maybe<Pick<SessionProductCoverage, 'mode' | 'legacy'>>,
  };

export type SessionAffiliationFieldsFragment = (
  Pick<SessionAffiliation, 'id' | 'kind'>
  & { organization: SessionOrganizationFieldsFragment }
);

export type SessionViewKeyFieldsFragment = Pick<
    SessionViewKey,
    | 'legalEntityId'
    | 'viewVersion'
    | 'mutationVersion'
    | 'viewType'
  >;

export type SessionOrganizationBrandingFieldsFragment = Pick<SessionOrganizationBranding, 'id' | 'headerColor' | 'headerTextColor'>;

export type TransactionPreviewFieldsFragment = (
  Pick<TransactionPreview, 'timestamp' | 'description' | 'displayEntry'>
  & { transactionName: TransactionPreview['name'] }
  & {
    party?: Maybe<PartyPreviewFieldsFragment>,
    creditCategory?: Maybe<CategoryPreviewFieldsFragment>,
    debitCategory?: Maybe<CategoryPreviewFieldsFragment>,
  }
);

export type ViewInvoiceSummaryFieldsFragment = (
  Pick<ViewInvoiceSummary, 'isPayable' | 'useNewPaymentProvider' | 'creditCardsEnabled'>
  & {
    invoice: InvoiceFieldsFragment,
    invoicePaymentDetails?: Maybe<PublicInvoicePaymentDetailsFieldsFragment>,
  }
);

export type AddSignupMutationVariables = Exact<{
  email: Scalars['String']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<Persona>;
  planIntent: PlanIntent;
  attribution?: InputMaybe<SignupAttribution>;
}>;


export type AddSignupMutation = { signup: PublicSignupFieldsFragment };

export type BeginLoginMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type BeginLoginMutation = { beginLogin: Pick<BeginLogin, 'requiresSSO' | 'ssoIssuerURL' | 'ssoOrganizationId'> };

export type CompleteMfaChallengeMutationVariables = Exact<{
  challengeToken: Scalars['String']['input'];
  code: Scalars['String']['input'];
  method: MfaMethod;
}>;


export type CompleteMfaChallengeMutation = { completeMfaChallenge: SessionFieldsFragment };

export type CreatePasswordResetMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  object?: InputMaybe<InputObjectIdentifier>;
  intentId?: InputMaybe<Scalars['String']['input']>;
  ledgerBillId?: InputMaybe<Scalars['String']['input']>;
  contactToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePasswordResetMutation = Pick<Mutation, 'createPasswordReset'>;

export type CreatePaymentPlaidLinkTokenMutationVariables = Exact<{
  plaidClientUserId: Scalars['String']['input'];
}>;


export type CreatePaymentPlaidLinkTokenMutation = { createPaymentPlaidLinkToken: Pick<PlaidLinkToken, 'token'> };

export type CreatePlaidGuestBankAccountInstrumentMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
  useNewPaymentProvider: Scalars['Boolean']['input'];
}>;


export type CreatePlaidGuestBankAccountInstrumentMutation = { createPlaidGuestBankAccountInstrument:
    | (
      { __typename: 'BankAccount' }
      & PublicBankAccountFieldsFragment
    )
    | { __typename: 'CreditCard' }
   };

export type HandleInvoiceCardPaymentActionMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentDetails: Scalars['String']['input'];
  billingAddress?: InputMaybe<CardBillingAddressInput>;
}>;


export type HandleInvoiceCardPaymentActionMutation = { handleInvoiceCardPaymentAction: Pick<
      InvoiceCardPaymentResult,
      | 'result'
      | 'paymentConfirmationId'
      | 'pspReference'
      | 'errorMessage'
      | 'cardBrand'
      | 'cardLastFour'
    > };

export type LedgerHandleInvoiceCardPaymentActionMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentDetails: Scalars['String']['input'];
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  expectedAmount: InputMonetaryValue;
}>;


export type LedgerHandleInvoiceCardPaymentActionMutation = { ledgerHandleInvoiceCardPaymentAction: Pick<
      InvoiceCardPaymentResult,
      | 'result'
      | 'paymentConfirmationId'
      | 'pspReference'
      | 'errorMessage'
      | 'cardBrand'
      | 'cardLastFour'
    > };

export type LedgerPayInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentInstrumentId: Scalars['String']['input'];
  expectedAmount: InputMonetaryValue;
}>;


export type LedgerPayInvoiceMutation = { ledgerPayInvoice: PublicPayInvoiceSummaryFieldsFragment };

export type LedgerSubmitInvoiceCardPaymentMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentMethodData: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  riskData?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  expectedAmount: InputMonetaryValue;
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerSubmitInvoiceCardPaymentMutation = { ledgerSubmitInvoiceCardPayment: Pick<
      InvoiceCardPaymentResult,
      | 'result'
      | 'paymentConfirmationId'
      | 'pspReference'
      | 'actionData'
      | 'errorMessage'
      | 'refusalReasonCode'
      | 'cardBrand'
      | 'cardLastFour'
    > };

export type LogInAppInstanceMutationVariables = Exact<{
  id: Scalars['String']['input'];
  challenge: AppInstanceChallenge;
  profile: AppInstanceProfile;
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogInAppInstanceMutation = { logInAppInstance: SessionFieldsFragment };

export type LogInEmailMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogInEmailMutation = { logInEmail: SessionFieldsFragment };

export type LogInMagicLinkMutationVariables = Exact<{
  token: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogInMagicLinkMutation = { logInMagicLink: SessionFieldsFragment };

export type LogInOAuthMutationVariables = Exact<{
  service: OAuthService;
  code: Scalars['String']['input'];
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogInOAuthMutation = { logInOAuth: SessionFieldsFragment };

export type LogInSupportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LogInSupportMutation = { logInSupport: Pick<Session, 'bearer'> };

export type LogOutSupportMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LogOutSupportMutation = { logOutSupport: Pick<Session, 'bearer'> };

export type PayInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  receivableInvoiceId?: InputMaybe<Scalars['String']['input']>;
  paymentInstrumentId: Scalars['String']['input'];
}>;


export type PayInvoiceMutation = { payInvoice: PublicPayInvoiceSummaryFieldsFragment };

export type ProvisionVerificationTokenMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  object: InputObjectIdentifier;
  intentId: Scalars['String']['input'];
}>;


export type ProvisionVerificationTokenMutation = { provisionVerificationToken: Pick<ConfirmationToken, 'token'> };

export type RegisterInviteOAuthMutationVariables = Exact<{
  invitationToken: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  code: Scalars['String']['input'];
  service: OAuthService;
}>;


export type RegisterInviteOAuthMutation = { registerInviteOAuth: Pick<Session, 'bearer'> };

export type RegisterInvitePasswordlessMutationVariables = Exact<{
  invitationToken: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterInvitePasswordlessMutation = { registerInvitePasswordless: Pick<Session, 'bearer'> };

export type RegisterUserEmailTokenMutationVariables = Exact<{
  confirmToken: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterUserEmailTokenMutation = { registerUserEmailToken: (
    Pick<RegistrationStatus, 'alreadyRegistered'>
    & { session?: Maybe<SessionFieldsFragment> }
  ) };

export type RegisterUserOAuthMutationVariables = Exact<{
  service: OAuthService;
  code: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  tosVersionAccepted?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterUserOAuthMutation = { registerUserOAuth: Pick<Session, 'bearer'> };

export type ResetPasswordMutationVariables = Exact<{
  resetToken: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { resetPassword: SessionFieldsFragment };

export type SendAcceptedInvitationMagicLinkMutationVariables = Exact<{
  invitationToken: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendAcceptedInvitationMagicLinkMutation = Pick<Mutation, 'sendAcceptedInvitationMagicLink'>;

export type SendEmailVerificationMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  destination: VerificationRequestDestination;
  object?: InputMaybe<InputObjectIdentifier>;
  intentId?: InputMaybe<Scalars['String']['input']>;
  constraint?: InputMaybe<AccessConstraint>;
  billId?: InputMaybe<Scalars['String']['input']>;
  contactToken?: InputMaybe<Scalars['String']['input']>;
  requestParameters?: InputMaybe<Array<RequestParameter> | RequestParameter>;
}>;


export type SendEmailVerificationMutation = Pick<Mutation, 'sendEmailVerification'>;

export type SendMagicLinkEmailMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  scheme?: InputMaybe<MagicLinkRequestScheme>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendMagicLinkEmailMutation = Pick<Mutation, 'sendMagicLinkEmail'>;

export type SubmitInvoiceCardPaymentMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentMethodData: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  riskData?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitInvoiceCardPaymentMutation = { submitInvoiceCardPayment: Pick<
      InvoiceCardPaymentResult,
      | 'result'
      | 'paymentConfirmationId'
      | 'pspReference'
      | 'actionData'
      | 'errorMessage'
      | 'refusalReasonCode'
      | 'cardBrand'
      | 'cardLastFour'
    > };

export type TokenRefreshMutationVariables = Exact<{
  activeLegalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TokenRefreshMutation = { tokenRefresh: SessionFieldsFragment };

export type UnsubscribeMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  notificationToken: Scalars['String']['input'];
}>;


export type UnsubscribeMutation = Pick<Mutation, 'unsubscribe'>;

export type GetInvoicePaymentMethodsQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  amount: InputMonetaryValue;
  payerLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  invoiceLegalEntityId: Scalars['String']['input'];
}>;


export type GetInvoicePaymentMethodsQuery = { getInvoicePaymentMethods: Pick<InvoicePaymentMethods, 'clientKey' | 'environment' | 'paymentMethodsResponse'> };

export type LedgerBillIdForBillPaymentQueryVariables = Exact<{
  billPaymentId: Scalars['String']['input'];
  contactToken: Scalars['String']['input'];
}>;


export type LedgerBillIdForBillPaymentQuery = { previewBillPayment: Pick<BillPaymentPreview, 'billId' | 'id'> };

export type PreviewLedgerBillQueryVariables = Exact<{
  id: Scalars['String']['input'];
  contactToken: Scalars['String']['input'];
}>;


export type PreviewLedgerBillQuery = { previewLedgerBill: PublicLedgerBillPreviewFieldsFragment };

export type PreviewShareQueryVariables = Exact<{
  kind: ObjectKind;
  id: Scalars['String']['input'];
  intentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PreviewShareQuery = { previewShare: (
    Pick<SharePreview, 'userEmail'>
    & {
      legalEntity: Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>,
      object:
        | (
          { __typename: 'CategoryPreview' }
          & CategoryPreviewFieldsFragment
        )
        | (
          { __typename: 'PartyPreview' }
          & PartyPreviewFieldsFragment
        )
        | (
          { __typename: 'ReportPackagePreview' }
          & Pick<
            ReportPackagePreview,
            | 'createdAt'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'interval'
            | 'title'
            | 'coverUrl'
            | 'preparedBy'
          >
          & { author: PublicEntityUserFieldsFragment }
        )
        | (
          { __typename: 'TransactionPreview' }
          & TransactionPreviewFieldsFragment
        )
      ,
    }
  ) };

export type PublicDocumentDownloadUrlQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  referenceId: Scalars['String']['input'];
}>;


export type PublicDocumentDownloadUrlQuery = { publicDocumentDownloadUrl: Pick<DocumentDownload, 'url'> };

export type ReadInvitationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ReadInvitationQuery = {
    readInvitation: (
      Pick<
        Invitation,
        | 'id'
        | 'service'
        | 'invitationType'
        | 'organizationTemplateId'
      >
      & {
        recipient: Pick<Contact, 'givenName' | 'familyName' | 'emailAddress'>,
        sender?: Maybe<Pick<Contact, 'givenName' | 'avatarUrl' | 'emailAddress'>>,
        organization?: Maybe<Pick<Organization, 'id' | 'slug' | 'name'>>,
        legalEntityRoles?: Maybe<Array<Pick<EmployeeLegalEntityRole, 'legalEntityId'>>>,
      }
    ),
    readInvitationRecipient: Pick<
        UserContact,
        | 'userId'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
  };

export type ReadInvitationRecipientQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ReadInvitationRecipientQuery = { readInvitationRecipient: Pick<
      UserContact,
      | 'userId'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    > };

export type ReadPasswordResetQueryVariables = Exact<{
  resetToken: Scalars['String']['input'];
}>;


export type ReadPasswordResetQuery = { readPasswordReset: (
    Pick<PasswordReset, 'isValid'>
    & { contact: Pick<
        Contact,
        | 'familyName'
        | 'givenName'
        | 'emailAddress'
        | 'avatarUrl'
      > }
  ) };

export type ReadSsoRequirementQueryVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type ReadSsoRequirementQuery = { readSSORequirement: Pick<SsoRequirement, 'requiresSSO' | 'ssoIssuerURL' | 'ssoOrganizationId'> };

export type ReadSignupQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadSignupQuery = { readSignup: PublicSignupFieldsFragment };

export type ViewInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ViewInvoiceQuery = { viewInvoice: ViewInvoiceSummaryFieldsFragment };

export type ViewInvoiceFilesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type ViewInvoiceFilesQuery = { viewInvoiceFiles: Array<PublicInvoiceFileFieldsFragment> };

export type ReadW9CollectionDocumentQueryVariables = Exact<{
  viewPartyId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type ReadW9CollectionDocumentQuery = { readW9CollectionDocument: Pick<W9CollectionDocument, 'status' | 'asyncProcessingStatus'> };

export type ReadW9CollectionFeaturesQueryVariables = Exact<{
  viewPartyId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type ReadW9CollectionFeaturesQuery = { readW9CollectionFeatures: { features: Array<(
      Pick<Feature, 'id' | 'kind'>
      & { value:
        | { addressValue: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
            > }
        | Pick<TextFeatureValue, 'textValue'>
        | Record<PropertyKey, never>
       }
    )> } };

export type ReadW9RequesterQueryVariables = Exact<{
  viewPartyId: Scalars['String']['input'];
}>;


export type ReadW9RequesterQuery = { readW9Requester: Pick<W9Requester, 'name' | 'iconUrl' | 'completed'> };

export type SaveW9FormMutationVariables = Exact<{
  viewPartyId: Scalars['String']['input'];
  form: W9FormInput;
}>;


export type SaveW9FormMutation = Pick<Mutation, 'saveW9Form'>;

export type LogOutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogOutMutation = Pick<Mutation, 'logOut'>;

export const PublicEntityUserFieldsFragmentDoc = gql`
    fragment PublicEntityUserFields on EntityUser {
  id
  givenName
  familyName
  emailAddress
  avatarUrl
}
    `;
export const PublicMonetaryValueFieldsFragmentDoc = gql`
    fragment PublicMonetaryValueFields on MonetaryValue {
  iso4217CurrencyCode
  currencyMultiplier
  amount
}
    `;
export const PublicLedgerBillPreviewFieldsFragmentDoc = gql`
    fragment PublicLedgerBillPreviewFields on LedgerBillPreview {
  billId
  externalId
  payerCompanyName
  payerEmailAddress
  amount {
    ...PublicMonetaryValueFields
  }
  vendor {
    name
    email
  }
  invoiceDate {
    year
    month
    day
  }
  dueDate {
    year
    month
    day
  }
  image {
    collectionId
    fileId
    token
  }
}
    ${PublicMonetaryValueFieldsFragmentDoc}`;
export const PublicBankAccountFieldsFragmentDoc = gql`
    fragment PublicBankAccountFields on BankAccount {
  __typename
  id
  institutionName
  name
  accountIdMask
  isDefault
  nickname
  isAutoPayout
  iconObjectName
}
    `;
export const PublicCreditCardFieldsFragmentDoc = gql`
    fragment PublicCreditCardFields on CreditCard {
  __typename
  id
  cardLastFour
  cardBrand
}
    `;
export const PublicInvoicePaymentDetailsFieldsFragmentDoc = gql`
    fragment PublicInvoicePaymentDetailsFields on InvoicePaymentDetails {
  paymentConfirmationId
  paymentDate
  paymentAmount {
    ...PublicMonetaryValueFields
  }
  paymentInstrument {
    ...PublicBankAccountFields
    ...PublicCreditCardFields
  }
}
    ${PublicMonetaryValueFieldsFragmentDoc}
${PublicBankAccountFieldsFragmentDoc}
${PublicCreditCardFieldsFragmentDoc}`;
export const PublicPayInvoiceSummaryFieldsFragmentDoc = gql`
    fragment PublicPayInvoiceSummaryFields on PayInvoiceSummary {
  invoicePaymentDetails {
    ...PublicInvoicePaymentDetailsFields
  }
  status
}
    ${PublicInvoicePaymentDetailsFieldsFragmentDoc}`;
export const PublicSignupFieldsFragmentDoc = gql`
    fragment PublicSignupFields on PublicSignup {
  id
  contact {
    avatarUrl
    familyName
    givenName
    emailAddress
  }
  positionTitle
  companyName
  companyURL
  companyLedger
  companyCurrency
  industry
  status
  persona
  verificationMethod
  planIntent
}
    `;
export const SessionOrganizationBrandingFieldsFragmentDoc = gql`
    fragment SessionOrganizationBrandingFields on SessionOrganizationBranding {
  id
  headerColor
  headerTextColor
}
    `;
export const SessionViewKeyFieldsFragmentDoc = gql`
    fragment SessionViewKeyFields on SessionViewKey {
  legalEntityId
  viewVersion
  mutationVersion
  viewType
}
    `;
export const SessionLegalEntityBillingFieldsFragmentDoc = gql`
    fragment SessionLegalEntityBillingFields on SessionLegalEntityBilling {
  payer {
    kind
    stripeSubscription
  }
  productCoverage {
    mode
    legacy
  }
}
    `;
export const SessionLegalEntityFieldsFragmentDoc = gql`
    fragment SessionLegalEntityFields on SessionLegalEntity {
  id
  name
  slug
  iconUrl
  status
  viewKeys {
    ...SessionViewKeyFields
  }
  aspects
  affiliatedOrganizationIds
  billing {
    ...SessionLegalEntityBillingFields
  }
}
    ${SessionViewKeyFieldsFragmentDoc}
${SessionLegalEntityBillingFieldsFragmentDoc}`;
export const SessionOrganizationFieldsFragmentDoc = gql`
    fragment SessionOrganizationFields on SessionOrganization {
  id
  name
  kind
  slug
  iconUrl
  websiteUrl
  aspects
  branding {
    ...SessionOrganizationBrandingFields
  }
  billing {
    stripeSubscription
    hasStripeSubscription
  }
  legalEntities {
    ...SessionLegalEntityFields
  }
}
    ${SessionOrganizationBrandingFieldsFragmentDoc}
${SessionLegalEntityFieldsFragmentDoc}`;
export const SessionAffiliationFieldsFragmentDoc = gql`
    fragment SessionAffiliationFields on SessionAffiliation {
  id
  kind
  organization {
    ...SessionOrganizationFields
  }
}
    ${SessionOrganizationFieldsFragmentDoc}`;
export const EmploymentFieldsFragmentDoc = gql`
    fragment EmploymentFields on SessionEmployment {
  id
  organization {
    ...SessionOrganizationFields
  }
  affiliations {
    ...SessionAffiliationFields
  }
}
    ${SessionOrganizationFieldsFragmentDoc}
${SessionAffiliationFieldsFragmentDoc}`;
export const SessionFieldsFragmentDoc = gql`
    fragment SessionFields on Session {
  bearer
  employments {
    ...EmploymentFields
  }
}
    ${EmploymentFieldsFragmentDoc}`;
export const PartyPreviewFieldsFragmentDoc = gql`
    fragment PartyPreviewFields on PartyPreview {
  id
  name
  iconUrl
}
    `;
export const CategoryPreviewFieldsFragmentDoc = gql`
    fragment CategoryPreviewFields on CategoryPreview {
  name
  displayKey
  type
}
    `;
export const TransactionPreviewFieldsFragmentDoc = gql`
    fragment TransactionPreviewFields on TransactionPreview {
  timestamp
  transactionName: name
  description
  party {
    ...PartyPreviewFields
  }
  displayEntry
  creditCategory {
    ...CategoryPreviewFields
  }
  debitCategory {
    ...CategoryPreviewFields
  }
}
    ${PartyPreviewFieldsFragmentDoc}
${CategoryPreviewFieldsFragmentDoc}`;
export const PublicAddressFieldsFragmentDoc = gql`
    fragment PublicAddressFields on Address {
  street
  streetAdditional
  city
  region
  postalCode
  countryCode
  lat
  long
}
    `;
export const InvoiceAddressFieldsFragmentDoc = gql`
    fragment InvoiceAddressFields on InvoicingAddress {
  id
  address {
    ...PublicAddressFields
  }
}
    ${PublicAddressFieldsFragmentDoc}`;
export const InvoiceProfileFieldsFragmentDoc = gql`
    fragment InvoiceProfileFields on InvoicingProfile {
  id
  companyEmail
  companyName
  companyIcon
  companyAddress {
    ...InvoiceAddressFields
  }
  payoutInstrumentID
  invoiceNumberFormatDefault
  invoiceNumberFormat
}
    ${InvoiceAddressFieldsFragmentDoc}`;
export const PublicCustomerAddressFieldsFragmentDoc = gql`
    fragment PublicCustomerAddressFields on CustomerAddress {
  id
  address {
    ...PublicAddressFields
  }
}
    ${PublicAddressFieldsFragmentDoc}`;
export const PublicCustomerFieldsFragmentDoc = gql`
    fragment PublicCustomerFields on Customer {
  id
  name
  email
  icon
  address {
    ...PublicCustomerAddressFields
  }
  providerType
}
    ${PublicCustomerAddressFieldsFragmentDoc}`;
export const PublicInvoiceBrandingFieldsFragmentDoc = gql`
    fragment PublicInvoiceBrandingFields on InvoiceBranding {
  id
  backgroundColor
  coverURL
}
    `;
export const PublicDiscountFieldsFragmentDoc = gql`
    fragment PublicDiscountFields on Discount {
  discountId
  name
  fixedDiscountAmount {
    ...PublicMonetaryValueFields
  }
  variablePercentage
  providerType
}
    ${PublicMonetaryValueFieldsFragmentDoc}`;
export const PublicInvoiceDiscountFieldsFragmentDoc = gql`
    fragment PublicInvoiceDiscountFields on InvoiceDiscount {
  invoiceDiscountId
  discount {
    ...PublicDiscountFields
  }
  amount {
    ...PublicMonetaryValueFields
  }
  discountAmount {
    ...PublicMonetaryValueFields
  }
}
    ${PublicDiscountFieldsFragmentDoc}
${PublicMonetaryValueFieldsFragmentDoc}`;
export const PublicInvoiceLineItemFieldsFragmentDoc = gql`
    fragment PublicInvoiceLineItemFields on InvoiceLineItem {
  description
  id
  name
  amount {
    ...PublicMonetaryValueFields
  }
  unitPrice {
    ...PublicMonetaryValueFields
  }
  taxable
  productId
  sku
  imageUrl
  position
  discounts {
    ...PublicInvoiceDiscountFields
  }
  quantityValue {
    quantity
    quantityMultiplier
  }
}
    ${PublicMonetaryValueFieldsFragmentDoc}
${PublicInvoiceDiscountFieldsFragmentDoc}`;
export const PublicInvoiceFileFieldsFragmentDoc = gql`
    fragment PublicInvoiceFileFields on InvoiceFile {
  documentId
  fileType
}
    `;
export const InvoiceFieldsFragmentDoc = gql`
    fragment InvoiceFields on PublicInvoice {
  id
  receivableInvoiceId
  legalEntityId
  status
  invoicingProfile {
    ...InvoiceProfileFields
  }
  customer {
    ...PublicCustomerFields
  }
  branding {
    ...PublicInvoiceBrandingFields
  }
  invoiceNumber
  invoiceDate
  dueDate
  lineItems {
    ...PublicInvoiceLineItemFields
  }
  taxPercent
  totalTax {
    ...PublicMonetaryValueFields
  }
  subtotal {
    ...PublicMonetaryValueFields
  }
  totalAmount {
    ...PublicMonetaryValueFields
  }
  memo
  referenceNumber
  discounts {
    ...PublicInvoiceDiscountFields
  }
  files {
    ...PublicInvoiceFileFields
  }
}
    ${InvoiceProfileFieldsFragmentDoc}
${PublicCustomerFieldsFragmentDoc}
${PublicInvoiceBrandingFieldsFragmentDoc}
${PublicInvoiceLineItemFieldsFragmentDoc}
${PublicMonetaryValueFieldsFragmentDoc}
${PublicInvoiceDiscountFieldsFragmentDoc}
${PublicInvoiceFileFieldsFragmentDoc}`;
export const ViewInvoiceSummaryFieldsFragmentDoc = gql`
    fragment ViewInvoiceSummaryFields on ViewInvoiceSummary {
  invoice {
    ...InvoiceFields
  }
  invoicePaymentDetails {
    ...PublicInvoicePaymentDetailsFields
  }
  isPayable
  useNewPaymentProvider
  creditCardsEnabled
}
    ${InvoiceFieldsFragmentDoc}
${PublicInvoicePaymentDetailsFieldsFragmentDoc}`;
export const AddSignupDocument = gql`
    mutation AddSignup($email: String!, $givenName: String, $familyName: String, $timezone: String, $persona: Persona, $planIntent: PlanIntent!, $attribution: SignupAttribution) {
  signup: addSignup(
    email: $email
    givenName: $givenName
    familyName: $familyName
    timezone: $timezone
    persona: $persona
    planIntent: $planIntent
    attribution: $attribution
  ) {
    ...PublicSignupFields
  }
}
    ${PublicSignupFieldsFragmentDoc}`;
export type AddSignupMutationFn = Apollo.MutationFunction<AddSignupMutation, AddSignupMutationVariables>;
export function useAddSignupMutation(baseOptions?: Apollo.MutationHookOptions<AddSignupMutation, AddSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSignupMutation, AddSignupMutationVariables>(AddSignupDocument, options);
      }
export type AddSignupMutationHookResult = ReturnType<typeof useAddSignupMutation>;
export type AddSignupMutationResult = Apollo.MutationResult<AddSignupMutation>;
export const BeginLoginDocument = gql`
    mutation BeginLogin($emailAddress: String!, $redirectPath: String, $scheme: MagicLinkRequestScheme, $state: String) {
  beginLogin(
    emailAddress: $emailAddress
    redirectPath: $redirectPath
    scheme: $scheme
    state: $state
  ) {
    requiresSSO
    ssoIssuerURL
    ssoOrganizationId
  }
}
    `;
export type BeginLoginMutationFn = Apollo.MutationFunction<BeginLoginMutation, BeginLoginMutationVariables>;
export function useBeginLoginMutation(baseOptions?: Apollo.MutationHookOptions<BeginLoginMutation, BeginLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BeginLoginMutation, BeginLoginMutationVariables>(BeginLoginDocument, options);
      }
export type BeginLoginMutationHookResult = ReturnType<typeof useBeginLoginMutation>;
export type BeginLoginMutationResult = Apollo.MutationResult<BeginLoginMutation>;
export const CompleteMfaChallengeDocument = gql`
    mutation CompleteMfaChallenge($challengeToken: String!, $code: String!, $method: MfaMethod!) {
  completeMfaChallenge(
    challengeToken: $challengeToken
    code: $code
    method: $method
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type CompleteMfaChallengeMutationFn = Apollo.MutationFunction<CompleteMfaChallengeMutation, CompleteMfaChallengeMutationVariables>;
export function useCompleteMfaChallengeMutation(baseOptions?: Apollo.MutationHookOptions<CompleteMfaChallengeMutation, CompleteMfaChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteMfaChallengeMutation, CompleteMfaChallengeMutationVariables>(CompleteMfaChallengeDocument, options);
      }
export type CompleteMfaChallengeMutationHookResult = ReturnType<typeof useCompleteMfaChallengeMutation>;
export type CompleteMfaChallengeMutationResult = Apollo.MutationResult<CompleteMfaChallengeMutation>;
export const CreatePasswordResetDocument = gql`
    mutation CreatePasswordReset($emailAddress: String!, $object: InputObjectIdentifier, $intentId: String, $ledgerBillId: String, $contactToken: String) {
  createPasswordReset(
    emailAddress: $emailAddress
    object: $object
    intentId: $intentId
    ledgerBillId: $ledgerBillId
    contactToken: $contactToken
  )
}
    `;
export type CreatePasswordResetMutationFn = Apollo.MutationFunction<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>;
export function useCreatePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>(CreatePasswordResetDocument, options);
      }
export type CreatePasswordResetMutationHookResult = ReturnType<typeof useCreatePasswordResetMutation>;
export type CreatePasswordResetMutationResult = Apollo.MutationResult<CreatePasswordResetMutation>;
export const CreatePaymentPlaidLinkTokenDocument = gql`
    mutation CreatePaymentPlaidLinkToken($plaidClientUserId: String!) {
  createPaymentPlaidLinkToken(plaidClientUserId: $plaidClientUserId) {
    token
  }
}
    `;
export type CreatePaymentPlaidLinkTokenMutationFn = Apollo.MutationFunction<CreatePaymentPlaidLinkTokenMutation, CreatePaymentPlaidLinkTokenMutationVariables>;
export function useCreatePaymentPlaidLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentPlaidLinkTokenMutation, CreatePaymentPlaidLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentPlaidLinkTokenMutation, CreatePaymentPlaidLinkTokenMutationVariables>(CreatePaymentPlaidLinkTokenDocument, options);
      }
export type CreatePaymentPlaidLinkTokenMutationHookResult = ReturnType<typeof useCreatePaymentPlaidLinkTokenMutation>;
export type CreatePaymentPlaidLinkTokenMutationResult = Apollo.MutationResult<CreatePaymentPlaidLinkTokenMutation>;
export const CreatePlaidGuestBankAccountInstrumentDocument = gql`
    mutation CreatePlaidGuestBankAccountInstrument($invoiceId: String!, $publicToken: String!, $accountId: String!, $institutionName: String!, $useNewPaymentProvider: Boolean!) {
  createPlaidGuestBankAccountInstrument(
    invoiceId: $invoiceId
    publicToken: $publicToken
    accountId: $accountId
    institutionName: $institutionName
    useNewPaymentProvider: $useNewPaymentProvider
  ) {
    __typename
    ...PublicBankAccountFields
  }
}
    ${PublicBankAccountFieldsFragmentDoc}`;
export type CreatePlaidGuestBankAccountInstrumentMutationFn = Apollo.MutationFunction<CreatePlaidGuestBankAccountInstrumentMutation, CreatePlaidGuestBankAccountInstrumentMutationVariables>;
export function useCreatePlaidGuestBankAccountInstrumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaidGuestBankAccountInstrumentMutation, CreatePlaidGuestBankAccountInstrumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaidGuestBankAccountInstrumentMutation, CreatePlaidGuestBankAccountInstrumentMutationVariables>(CreatePlaidGuestBankAccountInstrumentDocument, options);
      }
export type CreatePlaidGuestBankAccountInstrumentMutationHookResult = ReturnType<typeof useCreatePlaidGuestBankAccountInstrumentMutation>;
export type CreatePlaidGuestBankAccountInstrumentMutationResult = Apollo.MutationResult<CreatePlaidGuestBankAccountInstrumentMutation>;
export const HandleInvoiceCardPaymentActionDocument = gql`
    mutation HandleInvoiceCardPaymentAction($invoiceId: String!, $paymentDetails: String!, $billingAddress: CardBillingAddressInput) {
  handleInvoiceCardPaymentAction(
    invoiceId: $invoiceId
    paymentDetails: $paymentDetails
    billingAddress: $billingAddress
  ) {
    result
    paymentConfirmationId
    pspReference
    errorMessage
    cardBrand
    cardLastFour
  }
}
    `;
export type HandleInvoiceCardPaymentActionMutationFn = Apollo.MutationFunction<HandleInvoiceCardPaymentActionMutation, HandleInvoiceCardPaymentActionMutationVariables>;
export function useHandleInvoiceCardPaymentActionMutation(baseOptions?: Apollo.MutationHookOptions<HandleInvoiceCardPaymentActionMutation, HandleInvoiceCardPaymentActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleInvoiceCardPaymentActionMutation, HandleInvoiceCardPaymentActionMutationVariables>(HandleInvoiceCardPaymentActionDocument, options);
      }
export type HandleInvoiceCardPaymentActionMutationHookResult = ReturnType<typeof useHandleInvoiceCardPaymentActionMutation>;
export type HandleInvoiceCardPaymentActionMutationResult = Apollo.MutationResult<HandleInvoiceCardPaymentActionMutation>;
export const LedgerHandleInvoiceCardPaymentActionDocument = gql`
    mutation LedgerHandleInvoiceCardPaymentAction($invoiceId: String!, $paymentDetails: String!, $billingAddress: CardBillingAddressInput, $expectedAmount: InputMonetaryValue!) {
  ledgerHandleInvoiceCardPaymentAction(
    invoiceId: $invoiceId
    paymentDetails: $paymentDetails
    billingAddress: $billingAddress
    expectedAmount: $expectedAmount
  ) {
    result
    paymentConfirmationId
    pspReference
    errorMessage
    cardBrand
    cardLastFour
  }
}
    `;
export type LedgerHandleInvoiceCardPaymentActionMutationFn = Apollo.MutationFunction<LedgerHandleInvoiceCardPaymentActionMutation, LedgerHandleInvoiceCardPaymentActionMutationVariables>;
export function useLedgerHandleInvoiceCardPaymentActionMutation(baseOptions?: Apollo.MutationHookOptions<LedgerHandleInvoiceCardPaymentActionMutation, LedgerHandleInvoiceCardPaymentActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerHandleInvoiceCardPaymentActionMutation, LedgerHandleInvoiceCardPaymentActionMutationVariables>(LedgerHandleInvoiceCardPaymentActionDocument, options);
      }
export type LedgerHandleInvoiceCardPaymentActionMutationHookResult = ReturnType<typeof useLedgerHandleInvoiceCardPaymentActionMutation>;
export type LedgerHandleInvoiceCardPaymentActionMutationResult = Apollo.MutationResult<LedgerHandleInvoiceCardPaymentActionMutation>;
export const LedgerPayInvoiceDocument = gql`
    mutation LedgerPayInvoice($invoiceId: String!, $paymentInstrumentId: String!, $expectedAmount: InputMonetaryValue!) {
  ledgerPayInvoice(
    invoiceId: $invoiceId
    paymentInstrumentId: $paymentInstrumentId
    expectedAmount: $expectedAmount
  ) {
    ...PublicPayInvoiceSummaryFields
  }
}
    ${PublicPayInvoiceSummaryFieldsFragmentDoc}`;
export type LedgerPayInvoiceMutationFn = Apollo.MutationFunction<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>;
export function useLedgerPayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>(LedgerPayInvoiceDocument, options);
      }
export type LedgerPayInvoiceMutationHookResult = ReturnType<typeof useLedgerPayInvoiceMutation>;
export type LedgerPayInvoiceMutationResult = Apollo.MutationResult<LedgerPayInvoiceMutation>;
export const LedgerSubmitInvoiceCardPaymentDocument = gql`
    mutation LedgerSubmitInvoiceCardPayment($invoiceId: String!, $paymentMethodData: String!, $returnUrl: String!, $browserInfo: String, $riskData: String, $billingAddress: CardBillingAddressInput, $holderName: String, $expectedAmount: InputMonetaryValue!, $requestedTestAcquirerResponseCode: String) {
  ledgerSubmitInvoiceCardPayment(
    invoiceId: $invoiceId
    paymentMethodData: $paymentMethodData
    returnUrl: $returnUrl
    browserInfo: $browserInfo
    riskData: $riskData
    billingAddress: $billingAddress
    holderName: $holderName
    expectedAmount: $expectedAmount
    requestedTestAcquirerResponseCode: $requestedTestAcquirerResponseCode
  ) {
    result
    paymentConfirmationId
    pspReference
    actionData
    errorMessage
    refusalReasonCode
    cardBrand
    cardLastFour
  }
}
    `;
export type LedgerSubmitInvoiceCardPaymentMutationFn = Apollo.MutationFunction<LedgerSubmitInvoiceCardPaymentMutation, LedgerSubmitInvoiceCardPaymentMutationVariables>;
export function useLedgerSubmitInvoiceCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSubmitInvoiceCardPaymentMutation, LedgerSubmitInvoiceCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSubmitInvoiceCardPaymentMutation, LedgerSubmitInvoiceCardPaymentMutationVariables>(LedgerSubmitInvoiceCardPaymentDocument, options);
      }
export type LedgerSubmitInvoiceCardPaymentMutationHookResult = ReturnType<typeof useLedgerSubmitInvoiceCardPaymentMutation>;
export type LedgerSubmitInvoiceCardPaymentMutationResult = Apollo.MutationResult<LedgerSubmitInvoiceCardPaymentMutation>;
export const LogInAppInstanceDocument = gql`
    mutation LogInAppInstance($id: String!, $challenge: AppInstanceChallenge!, $profile: AppInstanceProfile!, $activeLegalEntityId: String) {
  logInAppInstance(
    id: $id
    challenge: $challenge
    profile: $profile
    activeLegalEntityId: $activeLegalEntityId
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type LogInAppInstanceMutationFn = Apollo.MutationFunction<LogInAppInstanceMutation, LogInAppInstanceMutationVariables>;
export function useLogInAppInstanceMutation(baseOptions?: Apollo.MutationHookOptions<LogInAppInstanceMutation, LogInAppInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInAppInstanceMutation, LogInAppInstanceMutationVariables>(LogInAppInstanceDocument, options);
      }
export type LogInAppInstanceMutationHookResult = ReturnType<typeof useLogInAppInstanceMutation>;
export type LogInAppInstanceMutationResult = Apollo.MutationResult<LogInAppInstanceMutation>;
export const LogInEmailDocument = gql`
    mutation LogInEmail($emailAddress: String!, $password: String!, $activeLegalEntityId: String) {
  logInEmail(
    emailAddress: $emailAddress
    password: $password
    activeLegalEntityId: $activeLegalEntityId
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type LogInEmailMutationFn = Apollo.MutationFunction<LogInEmailMutation, LogInEmailMutationVariables>;
export function useLogInEmailMutation(baseOptions?: Apollo.MutationHookOptions<LogInEmailMutation, LogInEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInEmailMutation, LogInEmailMutationVariables>(LogInEmailDocument, options);
      }
export type LogInEmailMutationHookResult = ReturnType<typeof useLogInEmailMutation>;
export type LogInEmailMutationResult = Apollo.MutationResult<LogInEmailMutation>;
export const LogInMagicLinkDocument = gql`
    mutation LogInMagicLink($token: String!, $state: String, $activeLegalEntityId: String) {
  logInMagicLink(
    token: $token
    state: $state
    activeLegalEntityId: $activeLegalEntityId
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type LogInMagicLinkMutationFn = Apollo.MutationFunction<LogInMagicLinkMutation, LogInMagicLinkMutationVariables>;
export function useLogInMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<LogInMagicLinkMutation, LogInMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInMagicLinkMutation, LogInMagicLinkMutationVariables>(LogInMagicLinkDocument, options);
      }
export type LogInMagicLinkMutationHookResult = ReturnType<typeof useLogInMagicLinkMutation>;
export type LogInMagicLinkMutationResult = Apollo.MutationResult<LogInMagicLinkMutation>;
export const LogInOAuthDocument = gql`
    mutation LogInOAuth($service: OAuthService!, $code: String!, $activeLegalEntityId: String) {
  logInOAuth(
    service: $service
    code: $code
    activeLegalEntityId: $activeLegalEntityId
  ) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type LogInOAuthMutationFn = Apollo.MutationFunction<LogInOAuthMutation, LogInOAuthMutationVariables>;
export function useLogInOAuthMutation(baseOptions?: Apollo.MutationHookOptions<LogInOAuthMutation, LogInOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInOAuthMutation, LogInOAuthMutationVariables>(LogInOAuthDocument, options);
      }
export type LogInOAuthMutationHookResult = ReturnType<typeof useLogInOAuthMutation>;
export type LogInOAuthMutationResult = Apollo.MutationResult<LogInOAuthMutation>;
export const LogInSupportDocument = gql`
    mutation LogInSupport($id: String!) {
  logInSupport(id: $id) {
    bearer
  }
}
    `;
export type LogInSupportMutationFn = Apollo.MutationFunction<LogInSupportMutation, LogInSupportMutationVariables>;
export function useLogInSupportMutation(baseOptions?: Apollo.MutationHookOptions<LogInSupportMutation, LogInSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogInSupportMutation, LogInSupportMutationVariables>(LogInSupportDocument, options);
      }
export type LogInSupportMutationHookResult = ReturnType<typeof useLogInSupportMutation>;
export type LogInSupportMutationResult = Apollo.MutationResult<LogInSupportMutation>;
export const LogOutSupportDocument = gql`
    mutation LogOutSupport($id: String!) {
  logOutSupport(id: $id) {
    bearer
  }
}
    `;
export type LogOutSupportMutationFn = Apollo.MutationFunction<LogOutSupportMutation, LogOutSupportMutationVariables>;
export function useLogOutSupportMutation(baseOptions?: Apollo.MutationHookOptions<LogOutSupportMutation, LogOutSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogOutSupportMutation, LogOutSupportMutationVariables>(LogOutSupportDocument, options);
      }
export type LogOutSupportMutationHookResult = ReturnType<typeof useLogOutSupportMutation>;
export type LogOutSupportMutationResult = Apollo.MutationResult<LogOutSupportMutation>;
export const PayInvoiceDocument = gql`
    mutation PayInvoice($invoiceId: String!, $receivableInvoiceId: String, $paymentInstrumentId: String!) {
  payInvoice(
    invoiceId: $invoiceId
    receivableInvoiceId: $receivableInvoiceId
    paymentInstrumentId: $paymentInstrumentId
  ) {
    ...PublicPayInvoiceSummaryFields
  }
}
    ${PublicPayInvoiceSummaryFieldsFragmentDoc}`;
export type PayInvoiceMutationFn = Apollo.MutationFunction<PayInvoiceMutation, PayInvoiceMutationVariables>;
export function usePayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<PayInvoiceMutation, PayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayInvoiceMutation, PayInvoiceMutationVariables>(PayInvoiceDocument, options);
      }
export type PayInvoiceMutationHookResult = ReturnType<typeof usePayInvoiceMutation>;
export type PayInvoiceMutationResult = Apollo.MutationResult<PayInvoiceMutation>;
export const ProvisionVerificationTokenDocument = gql`
    mutation ProvisionVerificationToken($emailAddress: String!, $givenName: String!, $familyName: String!, $object: InputObjectIdentifier!, $intentId: String!) {
  provisionVerificationToken(
    givenName: $givenName
    familyName: $familyName
    emailAddress: $emailAddress
    object: $object
    intentId: $intentId
  ) {
    token
  }
}
    `;
export type ProvisionVerificationTokenMutationFn = Apollo.MutationFunction<ProvisionVerificationTokenMutation, ProvisionVerificationTokenMutationVariables>;
export function useProvisionVerificationTokenMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionVerificationTokenMutation, ProvisionVerificationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionVerificationTokenMutation, ProvisionVerificationTokenMutationVariables>(ProvisionVerificationTokenDocument, options);
      }
export type ProvisionVerificationTokenMutationHookResult = ReturnType<typeof useProvisionVerificationTokenMutation>;
export type ProvisionVerificationTokenMutationResult = Apollo.MutationResult<ProvisionVerificationTokenMutation>;
export const RegisterInviteOAuthDocument = gql`
    mutation RegisterInviteOAuth($invitationToken: String!, $timezone: String!, $code: String!, $service: OAuthService!) {
  registerInviteOAuth(
    invitationToken: $invitationToken
    timezone: $timezone
    code: $code
    service: $service
  ) {
    bearer
  }
}
    `;
export type RegisterInviteOAuthMutationFn = Apollo.MutationFunction<RegisterInviteOAuthMutation, RegisterInviteOAuthMutationVariables>;
export function useRegisterInviteOAuthMutation(baseOptions?: Apollo.MutationHookOptions<RegisterInviteOAuthMutation, RegisterInviteOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterInviteOAuthMutation, RegisterInviteOAuthMutationVariables>(RegisterInviteOAuthDocument, options);
      }
export type RegisterInviteOAuthMutationHookResult = ReturnType<typeof useRegisterInviteOAuthMutation>;
export type RegisterInviteOAuthMutationResult = Apollo.MutationResult<RegisterInviteOAuthMutation>;
export const RegisterInvitePasswordlessDocument = gql`
    mutation RegisterInvitePasswordless($invitationToken: String!, $timezone: String!, $tosVersionAccepted: String, $givenName: String, $familyName: String) {
  registerInvitePasswordless(
    invitationToken: $invitationToken
    timezone: $timezone
    tosVersionAccepted: $tosVersionAccepted
    givenName: $givenName
    familyName: $familyName
  ) {
    bearer
  }
}
    `;
export type RegisterInvitePasswordlessMutationFn = Apollo.MutationFunction<RegisterInvitePasswordlessMutation, RegisterInvitePasswordlessMutationVariables>;
export function useRegisterInvitePasswordlessMutation(baseOptions?: Apollo.MutationHookOptions<RegisterInvitePasswordlessMutation, RegisterInvitePasswordlessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterInvitePasswordlessMutation, RegisterInvitePasswordlessMutationVariables>(RegisterInvitePasswordlessDocument, options);
      }
export type RegisterInvitePasswordlessMutationHookResult = ReturnType<typeof useRegisterInvitePasswordlessMutation>;
export type RegisterInvitePasswordlessMutationResult = Apollo.MutationResult<RegisterInvitePasswordlessMutation>;
export const RegisterUserEmailTokenDocument = gql`
    mutation RegisterUserEmailToken($confirmToken: String!, $timezone: String!, $password: String, $tosVersionAccepted: String, $givenName: String, $familyName: String) {
  registerUserEmailToken(
    confirmToken: $confirmToken
    timezone: $timezone
    password: $password
    tosVersionAccepted: $tosVersionAccepted
    givenName: $givenName
    familyName: $familyName
  ) {
    session {
      ...SessionFields
    }
    alreadyRegistered
  }
}
    ${SessionFieldsFragmentDoc}`;
export type RegisterUserEmailTokenMutationFn = Apollo.MutationFunction<RegisterUserEmailTokenMutation, RegisterUserEmailTokenMutationVariables>;
export function useRegisterUserEmailTokenMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserEmailTokenMutation, RegisterUserEmailTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserEmailTokenMutation, RegisterUserEmailTokenMutationVariables>(RegisterUserEmailTokenDocument, options);
      }
export type RegisterUserEmailTokenMutationHookResult = ReturnType<typeof useRegisterUserEmailTokenMutation>;
export type RegisterUserEmailTokenMutationResult = Apollo.MutationResult<RegisterUserEmailTokenMutation>;
export const RegisterUserOAuthDocument = gql`
    mutation RegisterUserOAuth($service: OAuthService!, $code: String!, $timezone: String!, $tosVersionAccepted: String) {
  registerUserOAuth(
    service: $service
    code: $code
    timezone: $timezone
    tosVersionAccepted: $tosVersionAccepted
  ) {
    bearer
  }
}
    `;
export type RegisterUserOAuthMutationFn = Apollo.MutationFunction<RegisterUserOAuthMutation, RegisterUserOAuthMutationVariables>;
export function useRegisterUserOAuthMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserOAuthMutation, RegisterUserOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserOAuthMutation, RegisterUserOAuthMutationVariables>(RegisterUserOAuthDocument, options);
      }
export type RegisterUserOAuthMutationHookResult = ReturnType<typeof useRegisterUserOAuthMutation>;
export type RegisterUserOAuthMutationResult = Apollo.MutationResult<RegisterUserOAuthMutation>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($resetToken: String!, $newPassword: String!) {
  resetPassword(resetToken: $resetToken, newPassword: $newPassword) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export const SendAcceptedInvitationMagicLinkDocument = gql`
    mutation SendAcceptedInvitationMagicLink($invitationToken: String!, $redirectPath: String, $scheme: MagicLinkRequestScheme, $state: String) {
  sendAcceptedInvitationMagicLink(
    invitationToken: $invitationToken
    redirectPath: $redirectPath
    scheme: $scheme
    state: $state
  )
}
    `;
export type SendAcceptedInvitationMagicLinkMutationFn = Apollo.MutationFunction<SendAcceptedInvitationMagicLinkMutation, SendAcceptedInvitationMagicLinkMutationVariables>;
export function useSendAcceptedInvitationMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<SendAcceptedInvitationMagicLinkMutation, SendAcceptedInvitationMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAcceptedInvitationMagicLinkMutation, SendAcceptedInvitationMagicLinkMutationVariables>(SendAcceptedInvitationMagicLinkDocument, options);
      }
export type SendAcceptedInvitationMagicLinkMutationHookResult = ReturnType<typeof useSendAcceptedInvitationMagicLinkMutation>;
export type SendAcceptedInvitationMagicLinkMutationResult = Apollo.MutationResult<SendAcceptedInvitationMagicLinkMutation>;
export const SendEmailVerificationDocument = gql`
    mutation SendEmailVerification($emailAddress: String!, $givenName: String, $familyName: String, $destination: VerificationRequestDestination!, $object: InputObjectIdentifier, $intentId: String, $constraint: AccessConstraint, $billId: String, $contactToken: String, $requestParameters: [RequestParameter!]) {
  sendEmailVerification(
    givenName: $givenName
    familyName: $familyName
    emailAddress: $emailAddress
    destination: $destination
    object: $object
    intentId: $intentId
    constraint: $constraint
    billId: $billId
    contactToken: $contactToken
    requestParameters: $requestParameters
  )
}
    `;
export type SendEmailVerificationMutationFn = Apollo.MutationFunction<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>;
export function useSendEmailVerificationMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailVerificationMutation, SendEmailVerificationMutationVariables>(SendEmailVerificationDocument, options);
      }
export type SendEmailVerificationMutationHookResult = ReturnType<typeof useSendEmailVerificationMutation>;
export type SendEmailVerificationMutationResult = Apollo.MutationResult<SendEmailVerificationMutation>;
export const SendMagicLinkEmailDocument = gql`
    mutation SendMagicLinkEmail($emailAddress: String!, $redirectPath: String, $scheme: MagicLinkRequestScheme, $state: String) {
  sendMagicLinkEmail(
    emailAddress: $emailAddress
    redirectPath: $redirectPath
    scheme: $scheme
    state: $state
  )
}
    `;
export type SendMagicLinkEmailMutationFn = Apollo.MutationFunction<SendMagicLinkEmailMutation, SendMagicLinkEmailMutationVariables>;
export function useSendMagicLinkEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendMagicLinkEmailMutation, SendMagicLinkEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMagicLinkEmailMutation, SendMagicLinkEmailMutationVariables>(SendMagicLinkEmailDocument, options);
      }
export type SendMagicLinkEmailMutationHookResult = ReturnType<typeof useSendMagicLinkEmailMutation>;
export type SendMagicLinkEmailMutationResult = Apollo.MutationResult<SendMagicLinkEmailMutation>;
export const SubmitInvoiceCardPaymentDocument = gql`
    mutation SubmitInvoiceCardPayment($invoiceId: String!, $paymentMethodData: String!, $returnUrl: String!, $browserInfo: String, $riskData: String, $billingAddress: CardBillingAddressInput, $holderName: String, $requestedTestAcquirerResponseCode: String) {
  submitInvoiceCardPayment(
    invoiceId: $invoiceId
    paymentMethodData: $paymentMethodData
    returnUrl: $returnUrl
    browserInfo: $browserInfo
    riskData: $riskData
    billingAddress: $billingAddress
    holderName: $holderName
    requestedTestAcquirerResponseCode: $requestedTestAcquirerResponseCode
  ) {
    result
    paymentConfirmationId
    pspReference
    actionData
    errorMessage
    refusalReasonCode
    cardBrand
    cardLastFour
  }
}
    `;
export type SubmitInvoiceCardPaymentMutationFn = Apollo.MutationFunction<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>;
export function useSubmitInvoiceCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>(SubmitInvoiceCardPaymentDocument, options);
      }
export type SubmitInvoiceCardPaymentMutationHookResult = ReturnType<typeof useSubmitInvoiceCardPaymentMutation>;
export type SubmitInvoiceCardPaymentMutationResult = Apollo.MutationResult<SubmitInvoiceCardPaymentMutation>;
export const TokenRefreshDocument = gql`
    mutation TokenRefresh($activeLegalEntityId: String) {
  tokenRefresh(activeLegalEntityId: $activeLegalEntityId) {
    ...SessionFields
  }
}
    ${SessionFieldsFragmentDoc}`;
export type TokenRefreshMutationFn = Apollo.MutationFunction<TokenRefreshMutation, TokenRefreshMutationVariables>;
export function useTokenRefreshMutation(baseOptions?: Apollo.MutationHookOptions<TokenRefreshMutation, TokenRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TokenRefreshMutation, TokenRefreshMutationVariables>(TokenRefreshDocument, options);
      }
export type TokenRefreshMutationHookResult = ReturnType<typeof useTokenRefreshMutation>;
export type TokenRefreshMutationResult = Apollo.MutationResult<TokenRefreshMutation>;
export const UnsubscribeDocument = gql`
    mutation Unsubscribe($emailAddress: String!, $notificationToken: String!) {
  unsubscribe(emailAddress: $emailAddress, notificationToken: $notificationToken)
}
    `;
export type UnsubscribeMutationFn = Apollo.MutationFunction<UnsubscribeMutation, UnsubscribeMutationVariables>;
export function useUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeMutation, UnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument, options);
      }
export type UnsubscribeMutationHookResult = ReturnType<typeof useUnsubscribeMutation>;
export type UnsubscribeMutationResult = Apollo.MutationResult<UnsubscribeMutation>;
export const GetInvoicePaymentMethodsDocument = gql`
    query GetInvoicePaymentMethods($invoiceId: String!, $amount: InputMonetaryValue!, $payerLegalEntityId: String, $invoiceLegalEntityId: String!) {
  getInvoicePaymentMethods(
    invoiceId: $invoiceId
    amount: $amount
    payerLegalEntityId: $payerLegalEntityId
    invoiceLegalEntityId: $invoiceLegalEntityId
  ) {
    clientKey
    environment
    paymentMethodsResponse
  }
}
    `;
export function useGetInvoicePaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables> & ({ variables: GetInvoicePaymentMethodsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>(GetInvoicePaymentMethodsDocument, options);
      }
export function useGetInvoicePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>(GetInvoicePaymentMethodsDocument, options);
        }
export function useGetInvoicePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>(GetInvoicePaymentMethodsDocument, options);
        }
export type GetInvoicePaymentMethodsQueryHookResult = ReturnType<typeof useGetInvoicePaymentMethodsQuery>;
export type GetInvoicePaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetInvoicePaymentMethodsLazyQuery>;
export type GetInvoicePaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useGetInvoicePaymentMethodsSuspenseQuery>;
export type GetInvoicePaymentMethodsQueryResult = Apollo.QueryResult<GetInvoicePaymentMethodsQuery, GetInvoicePaymentMethodsQueryVariables>;
export const LedgerBillIdForBillPaymentDocument = gql`
    query LedgerBillIdForBillPayment($billPaymentId: String!, $contactToken: String!) {
  previewBillPayment(id: $billPaymentId, contactToken: $contactToken) {
    billId
    id
  }
}
    `;
export function useLedgerBillIdForBillPaymentQuery(baseOptions: Apollo.QueryHookOptions<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables> & ({ variables: LedgerBillIdForBillPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>(LedgerBillIdForBillPaymentDocument, options);
      }
export function useLedgerBillIdForBillPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>(LedgerBillIdForBillPaymentDocument, options);
        }
export function useLedgerBillIdForBillPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>(LedgerBillIdForBillPaymentDocument, options);
        }
export type LedgerBillIdForBillPaymentQueryHookResult = ReturnType<typeof useLedgerBillIdForBillPaymentQuery>;
export type LedgerBillIdForBillPaymentLazyQueryHookResult = ReturnType<typeof useLedgerBillIdForBillPaymentLazyQuery>;
export type LedgerBillIdForBillPaymentSuspenseQueryHookResult = ReturnType<typeof useLedgerBillIdForBillPaymentSuspenseQuery>;
export type LedgerBillIdForBillPaymentQueryResult = Apollo.QueryResult<LedgerBillIdForBillPaymentQuery, LedgerBillIdForBillPaymentQueryVariables>;
export const PreviewLedgerBillDocument = gql`
    query PreviewLedgerBill($id: String!, $contactToken: String!) {
  previewLedgerBill(id: $id, contactToken: $contactToken) {
    ...PublicLedgerBillPreviewFields
  }
}
    ${PublicLedgerBillPreviewFieldsFragmentDoc}`;
export function usePreviewLedgerBillQuery(baseOptions: Apollo.QueryHookOptions<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables> & ({ variables: PreviewLedgerBillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>(PreviewLedgerBillDocument, options);
      }
export function usePreviewLedgerBillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>(PreviewLedgerBillDocument, options);
        }
export function usePreviewLedgerBillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>(PreviewLedgerBillDocument, options);
        }
export type PreviewLedgerBillQueryHookResult = ReturnType<typeof usePreviewLedgerBillQuery>;
export type PreviewLedgerBillLazyQueryHookResult = ReturnType<typeof usePreviewLedgerBillLazyQuery>;
export type PreviewLedgerBillSuspenseQueryHookResult = ReturnType<typeof usePreviewLedgerBillSuspenseQuery>;
export type PreviewLedgerBillQueryResult = Apollo.QueryResult<PreviewLedgerBillQuery, PreviewLedgerBillQueryVariables>;
export const PreviewShareDocument = gql`
    query PreviewShare($kind: ObjectKind!, $id: String!, $intentId: String) {
  previewShare(kind: $kind, id: $id, intentId: $intentId) {
    legalEntity {
      id
      name
      slug
    }
    userEmail
    object {
      __typename
      ... on ReportPackagePreview {
        author {
          ...PublicEntityUserFields
        }
        createdAt
        periodStartedAt
        periodEndedAt
        interval
        title
        coverUrl
        preparedBy
      }
      ... on TransactionPreview {
        ...TransactionPreviewFields
      }
      ... on PartyPreview {
        ...PartyPreviewFields
      }
      ... on CategoryPreview {
        ...CategoryPreviewFields
      }
    }
  }
}
    ${PublicEntityUserFieldsFragmentDoc}
${TransactionPreviewFieldsFragmentDoc}
${PartyPreviewFieldsFragmentDoc}
${CategoryPreviewFieldsFragmentDoc}`;
export function usePreviewShareQuery(baseOptions: Apollo.QueryHookOptions<PreviewShareQuery, PreviewShareQueryVariables> & ({ variables: PreviewShareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewShareQuery, PreviewShareQueryVariables>(PreviewShareDocument, options);
      }
export function usePreviewShareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewShareQuery, PreviewShareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewShareQuery, PreviewShareQueryVariables>(PreviewShareDocument, options);
        }
export function usePreviewShareSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewShareQuery, PreviewShareQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewShareQuery, PreviewShareQueryVariables>(PreviewShareDocument, options);
        }
export type PreviewShareQueryHookResult = ReturnType<typeof usePreviewShareQuery>;
export type PreviewShareLazyQueryHookResult = ReturnType<typeof usePreviewShareLazyQuery>;
export type PreviewShareSuspenseQueryHookResult = ReturnType<typeof usePreviewShareSuspenseQuery>;
export type PreviewShareQueryResult = Apollo.QueryResult<PreviewShareQuery, PreviewShareQueryVariables>;
export const PublicDocumentDownloadUrlDocument = gql`
    query PublicDocumentDownloadUrl($documentId: String!, $referenceId: String!) {
  publicDocumentDownloadUrl(documentId: $documentId, referenceId: $referenceId) {
    url
  }
}
    `;
export function usePublicDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables> & ({ variables: PublicDocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>(PublicDocumentDownloadUrlDocument, options);
      }
export function usePublicDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>(PublicDocumentDownloadUrlDocument, options);
        }
export function usePublicDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>(PublicDocumentDownloadUrlDocument, options);
        }
export type PublicDocumentDownloadUrlQueryHookResult = ReturnType<typeof usePublicDocumentDownloadUrlQuery>;
export type PublicDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof usePublicDocumentDownloadUrlLazyQuery>;
export type PublicDocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof usePublicDocumentDownloadUrlSuspenseQuery>;
export type PublicDocumentDownloadUrlQueryResult = Apollo.QueryResult<PublicDocumentDownloadUrlQuery, PublicDocumentDownloadUrlQueryVariables>;
export const ReadInvitationDocument = gql`
    query ReadInvitation($token: String!) {
  readInvitation(token: $token) {
    id
    recipient {
      givenName
      familyName
      emailAddress
    }
    sender {
      givenName
      avatarUrl
      emailAddress
    }
    organization {
      id
      slug
      name
    }
    service
    invitationType
    organizationTemplateId
    legalEntityRoles {
      legalEntityId
    }
  }
  readInvitationRecipient(token: $token) {
    userId
    givenName
    familyName
    emailAddress
    avatarUrl
  }
}
    `;
export function useReadInvitationQuery(baseOptions: Apollo.QueryHookOptions<ReadInvitationQuery, ReadInvitationQueryVariables> & ({ variables: ReadInvitationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInvitationQuery, ReadInvitationQueryVariables>(ReadInvitationDocument, options);
      }
export function useReadInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInvitationQuery, ReadInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInvitationQuery, ReadInvitationQueryVariables>(ReadInvitationDocument, options);
        }
export function useReadInvitationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadInvitationQuery, ReadInvitationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInvitationQuery, ReadInvitationQueryVariables>(ReadInvitationDocument, options);
        }
export type ReadInvitationQueryHookResult = ReturnType<typeof useReadInvitationQuery>;
export type ReadInvitationLazyQueryHookResult = ReturnType<typeof useReadInvitationLazyQuery>;
export type ReadInvitationSuspenseQueryHookResult = ReturnType<typeof useReadInvitationSuspenseQuery>;
export type ReadInvitationQueryResult = Apollo.QueryResult<ReadInvitationQuery, ReadInvitationQueryVariables>;
export const ReadInvitationRecipientDocument = gql`
    query ReadInvitationRecipient($token: String!) {
  readInvitationRecipient(token: $token) {
    userId
    givenName
    familyName
    emailAddress
    avatarUrl
  }
}
    `;
export function useReadInvitationRecipientQuery(baseOptions: Apollo.QueryHookOptions<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables> & ({ variables: ReadInvitationRecipientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>(ReadInvitationRecipientDocument, options);
      }
export function useReadInvitationRecipientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>(ReadInvitationRecipientDocument, options);
        }
export function useReadInvitationRecipientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>(ReadInvitationRecipientDocument, options);
        }
export type ReadInvitationRecipientQueryHookResult = ReturnType<typeof useReadInvitationRecipientQuery>;
export type ReadInvitationRecipientLazyQueryHookResult = ReturnType<typeof useReadInvitationRecipientLazyQuery>;
export type ReadInvitationRecipientSuspenseQueryHookResult = ReturnType<typeof useReadInvitationRecipientSuspenseQuery>;
export type ReadInvitationRecipientQueryResult = Apollo.QueryResult<ReadInvitationRecipientQuery, ReadInvitationRecipientQueryVariables>;
export const ReadPasswordResetDocument = gql`
    query ReadPasswordReset($resetToken: String!) {
  readPasswordReset(resetToken: $resetToken) {
    isValid
    contact {
      familyName
      givenName
      emailAddress
      avatarUrl
    }
  }
}
    `;
export function useReadPasswordResetQuery(baseOptions: Apollo.QueryHookOptions<ReadPasswordResetQuery, ReadPasswordResetQueryVariables> & ({ variables: ReadPasswordResetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>(ReadPasswordResetDocument, options);
      }
export function useReadPasswordResetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>(ReadPasswordResetDocument, options);
        }
export function useReadPasswordResetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>(ReadPasswordResetDocument, options);
        }
export type ReadPasswordResetQueryHookResult = ReturnType<typeof useReadPasswordResetQuery>;
export type ReadPasswordResetLazyQueryHookResult = ReturnType<typeof useReadPasswordResetLazyQuery>;
export type ReadPasswordResetSuspenseQueryHookResult = ReturnType<typeof useReadPasswordResetSuspenseQuery>;
export type ReadPasswordResetQueryResult = Apollo.QueryResult<ReadPasswordResetQuery, ReadPasswordResetQueryVariables>;
export const ReadSsoRequirementDocument = gql`
    query ReadSSORequirement($emailAddress: String!) {
  readSSORequirement(emailAddress: $emailAddress) {
    requiresSSO
    ssoIssuerURL
    ssoOrganizationId
  }
}
    `;
export function useReadSsoRequirementQuery(baseOptions: Apollo.QueryHookOptions<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables> & ({ variables: ReadSsoRequirementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>(ReadSsoRequirementDocument, options);
      }
export function useReadSsoRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>(ReadSsoRequirementDocument, options);
        }
export function useReadSsoRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>(ReadSsoRequirementDocument, options);
        }
export type ReadSsoRequirementQueryHookResult = ReturnType<typeof useReadSsoRequirementQuery>;
export type ReadSsoRequirementLazyQueryHookResult = ReturnType<typeof useReadSsoRequirementLazyQuery>;
export type ReadSsoRequirementSuspenseQueryHookResult = ReturnType<typeof useReadSsoRequirementSuspenseQuery>;
export type ReadSsoRequirementQueryResult = Apollo.QueryResult<ReadSsoRequirementQuery, ReadSsoRequirementQueryVariables>;
export const ReadSignupDocument = gql`
    query ReadSignup($id: String!) {
  readSignup(id: $id) {
    ...PublicSignupFields
  }
}
    ${PublicSignupFieldsFragmentDoc}`;
export function useReadSignupQuery(baseOptions: Apollo.QueryHookOptions<ReadSignupQuery, ReadSignupQueryVariables> & ({ variables: ReadSignupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSignupQuery, ReadSignupQueryVariables>(ReadSignupDocument, options);
      }
export function useReadSignupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSignupQuery, ReadSignupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSignupQuery, ReadSignupQueryVariables>(ReadSignupDocument, options);
        }
export function useReadSignupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSignupQuery, ReadSignupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSignupQuery, ReadSignupQueryVariables>(ReadSignupDocument, options);
        }
export type ReadSignupQueryHookResult = ReturnType<typeof useReadSignupQuery>;
export type ReadSignupLazyQueryHookResult = ReturnType<typeof useReadSignupLazyQuery>;
export type ReadSignupSuspenseQueryHookResult = ReturnType<typeof useReadSignupSuspenseQuery>;
export type ReadSignupQueryResult = Apollo.QueryResult<ReadSignupQuery, ReadSignupQueryVariables>;
export const ViewInvoiceDocument = gql`
    query ViewInvoice($id: String!) {
  viewInvoice(id: $id) {
    ...ViewInvoiceSummaryFields
  }
}
    ${ViewInvoiceSummaryFieldsFragmentDoc}`;
export function useViewInvoiceQuery(baseOptions: Apollo.QueryHookOptions<ViewInvoiceQuery, ViewInvoiceQueryVariables> & ({ variables: ViewInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewInvoiceQuery, ViewInvoiceQueryVariables>(ViewInvoiceDocument, options);
      }
export function useViewInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewInvoiceQuery, ViewInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewInvoiceQuery, ViewInvoiceQueryVariables>(ViewInvoiceDocument, options);
        }
export function useViewInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewInvoiceQuery, ViewInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewInvoiceQuery, ViewInvoiceQueryVariables>(ViewInvoiceDocument, options);
        }
export type ViewInvoiceQueryHookResult = ReturnType<typeof useViewInvoiceQuery>;
export type ViewInvoiceLazyQueryHookResult = ReturnType<typeof useViewInvoiceLazyQuery>;
export type ViewInvoiceSuspenseQueryHookResult = ReturnType<typeof useViewInvoiceSuspenseQuery>;
export type ViewInvoiceQueryResult = Apollo.QueryResult<ViewInvoiceQuery, ViewInvoiceQueryVariables>;
export const ViewInvoiceFilesDocument = gql`
    query ViewInvoiceFiles($legalEntityId: String!, $id: String!) {
  viewInvoiceFiles(legalEntityId: $legalEntityId, id: $id) {
    ...PublicInvoiceFileFields
  }
}
    ${PublicInvoiceFileFieldsFragmentDoc}`;
export function useViewInvoiceFilesQuery(baseOptions: Apollo.QueryHookOptions<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables> & ({ variables: ViewInvoiceFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>(ViewInvoiceFilesDocument, options);
      }
export function useViewInvoiceFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>(ViewInvoiceFilesDocument, options);
        }
export function useViewInvoiceFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>(ViewInvoiceFilesDocument, options);
        }
export type ViewInvoiceFilesQueryHookResult = ReturnType<typeof useViewInvoiceFilesQuery>;
export type ViewInvoiceFilesLazyQueryHookResult = ReturnType<typeof useViewInvoiceFilesLazyQuery>;
export type ViewInvoiceFilesSuspenseQueryHookResult = ReturnType<typeof useViewInvoiceFilesSuspenseQuery>;
export type ViewInvoiceFilesQueryResult = Apollo.QueryResult<ViewInvoiceFilesQuery, ViewInvoiceFilesQueryVariables>;
export const ReadW9CollectionDocumentDocument = gql`
    query ReadW9CollectionDocument($viewPartyId: String!, $documentId: String!) {
  readW9CollectionDocument(viewPartyId: $viewPartyId, documentId: $documentId) {
    status
    asyncProcessingStatus
  }
}
    `;
export function useReadW9CollectionDocumentQuery(baseOptions: Apollo.QueryHookOptions<ReadW9CollectionDocumentQuery, ReadW9CollectionDocumentQueryVariables> & ({ variables: ReadW9CollectionDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadW9CollectionDocumentQuery, ReadW9CollectionDocumentQueryVariables>(ReadW9CollectionDocumentDocument, options);
      }
export function useReadW9CollectionDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadW9CollectionDocumentQuery, ReadW9CollectionDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadW9CollectionDocumentQuery, ReadW9CollectionDocumentQueryVariables>(ReadW9CollectionDocumentDocument, options);
        }
export function useReadW9CollectionDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadW9CollectionDocumentQuery, ReadW9CollectionDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadW9CollectionDocumentQuery, ReadW9CollectionDocumentQueryVariables>(ReadW9CollectionDocumentDocument, options);
        }
export type ReadW9CollectionDocumentQueryHookResult = ReturnType<typeof useReadW9CollectionDocumentQuery>;
export type ReadW9CollectionDocumentLazyQueryHookResult = ReturnType<typeof useReadW9CollectionDocumentLazyQuery>;
export type ReadW9CollectionDocumentSuspenseQueryHookResult = ReturnType<typeof useReadW9CollectionDocumentSuspenseQuery>;
export type ReadW9CollectionDocumentQueryResult = Apollo.QueryResult<ReadW9CollectionDocumentQuery, ReadW9CollectionDocumentQueryVariables>;
export const ReadW9CollectionFeaturesDocument = gql`
    query ReadW9CollectionFeatures($viewPartyId: String!, $documentId: String!) {
  readW9CollectionFeatures(viewPartyId: $viewPartyId, documentId: $documentId) {
    features {
      id
      kind
      value {
        ... on TextFeatureValue {
          textValue
        }
        ... on AddressFeatureValue {
          addressValue {
            street
            streetAdditional
            city
            region
            postalCode
            countryCode
          }
        }
      }
    }
  }
}
    `;
export function useReadW9CollectionFeaturesQuery(baseOptions: Apollo.QueryHookOptions<ReadW9CollectionFeaturesQuery, ReadW9CollectionFeaturesQueryVariables> & ({ variables: ReadW9CollectionFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadW9CollectionFeaturesQuery, ReadW9CollectionFeaturesQueryVariables>(ReadW9CollectionFeaturesDocument, options);
      }
export function useReadW9CollectionFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadW9CollectionFeaturesQuery, ReadW9CollectionFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadW9CollectionFeaturesQuery, ReadW9CollectionFeaturesQueryVariables>(ReadW9CollectionFeaturesDocument, options);
        }
export function useReadW9CollectionFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadW9CollectionFeaturesQuery, ReadW9CollectionFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadW9CollectionFeaturesQuery, ReadW9CollectionFeaturesQueryVariables>(ReadW9CollectionFeaturesDocument, options);
        }
export type ReadW9CollectionFeaturesQueryHookResult = ReturnType<typeof useReadW9CollectionFeaturesQuery>;
export type ReadW9CollectionFeaturesLazyQueryHookResult = ReturnType<typeof useReadW9CollectionFeaturesLazyQuery>;
export type ReadW9CollectionFeaturesSuspenseQueryHookResult = ReturnType<typeof useReadW9CollectionFeaturesSuspenseQuery>;
export type ReadW9CollectionFeaturesQueryResult = Apollo.QueryResult<ReadW9CollectionFeaturesQuery, ReadW9CollectionFeaturesQueryVariables>;
export const ReadW9RequesterDocument = gql`
    query ReadW9Requester($viewPartyId: String!) {
  readW9Requester(viewPartyId: $viewPartyId) {
    name
    iconUrl
    completed
  }
}
    `;
export function useReadW9RequesterQuery(baseOptions: Apollo.QueryHookOptions<ReadW9RequesterQuery, ReadW9RequesterQueryVariables> & ({ variables: ReadW9RequesterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadW9RequesterQuery, ReadW9RequesterQueryVariables>(ReadW9RequesterDocument, options);
      }
export function useReadW9RequesterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadW9RequesterQuery, ReadW9RequesterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadW9RequesterQuery, ReadW9RequesterQueryVariables>(ReadW9RequesterDocument, options);
        }
export function useReadW9RequesterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadW9RequesterQuery, ReadW9RequesterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadW9RequesterQuery, ReadW9RequesterQueryVariables>(ReadW9RequesterDocument, options);
        }
export type ReadW9RequesterQueryHookResult = ReturnType<typeof useReadW9RequesterQuery>;
export type ReadW9RequesterLazyQueryHookResult = ReturnType<typeof useReadW9RequesterLazyQuery>;
export type ReadW9RequesterSuspenseQueryHookResult = ReturnType<typeof useReadW9RequesterSuspenseQuery>;
export type ReadW9RequesterQueryResult = Apollo.QueryResult<ReadW9RequesterQuery, ReadW9RequesterQueryVariables>;
export const SaveW9FormDocument = gql`
    mutation SaveW9Form($viewPartyId: String!, $form: W9FormInput!) {
  saveW9Form(viewPartyId: $viewPartyId, form: $form)
}
    `;
export type SaveW9FormMutationFn = Apollo.MutationFunction<SaveW9FormMutation, SaveW9FormMutationVariables>;
export function useSaveW9FormMutation(baseOptions?: Apollo.MutationHookOptions<SaveW9FormMutation, SaveW9FormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveW9FormMutation, SaveW9FormMutationVariables>(SaveW9FormDocument, options);
      }
export type SaveW9FormMutationHookResult = ReturnType<typeof useSaveW9FormMutation>;
export type SaveW9FormMutationResult = Apollo.MutationResult<SaveW9FormMutation>;
export const LogOutDocument = gql`
    mutation LogOut {
  logOut
}
    `;
export type LogOutMutationFn = Apollo.MutationFunction<LogOutMutation, LogOutMutationVariables>;
export function useLogOutMutation(baseOptions?: Apollo.MutationHookOptions<LogOutMutation, LogOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogOutMutation, LogOutMutationVariables>(LogOutDocument, options);
      }
export type LogOutMutationHookResult = ReturnType<typeof useLogOutMutation>;
export type LogOutMutationResult = Apollo.MutationResult<LogOutMutation>;